import React, { useState, useEffect } from 'react'
import { dataService } from '@/lib/dataService'
import * as XLSX from 'xlsx'

export const AdminAcademic: React.FC = () => {
  const [students, setStudents] = useState<any[]>([])
  const [scores, setScores] = useState<any[]>([])
  const [subjects, setSubjects] = useState<any[]>([])
  const [classrooms, setClassrooms] = useState<any[]>([])
  const [roomTypes, setRoomTypes] = useState<string[]>([])
  const [loading, setLoading] = useState(true)
  const [notification, setNotification] = useState<{ type: 'success' | 'error'; message: string } | null>(null)

  // Active Tab
  const [activeTab, setActiveTab] = useState<'students' | 'subjects' | 'imports' | 'assignments' | 'cleanup'>('students')

  // Modals visibility
  const [showAddStudentModal, setShowAddStudentModal] = useState(false)
  const [showEditStudentModal, setShowEditStudentModal] = useState<any>(null)
  const [showAddSubjectModal, setShowAddSubjectModal] = useState(false)
  const [showRoomTypeModal, setShowRoomTypeModal] = useState(false)
  const [showAddAssignmentModal, setShowAddAssignmentModal] = useState(false)
  const [showDepartmentModal, setShowDepartmentModal] = useState(false)

  // New room type input
  const [newRoomTypeVal, setNewRoomTypeVal] = useState('')
  const [newDeptNameVal, setNewDeptNameVal] = useState('')
  const [departments, setDepartments] = useState<any[]>([])

  // Inline edit states
  const [editingDeptId, setEditingDeptId] = useState<number | null>(null)
  const [editingDeptVal, setEditingDeptVal] = useState('')
  const [editingRoomTypeVal, setEditingRoomTypeVal] = useState<string | null>(null)
  const [editingRoomTypeInput, setEditingRoomTypeInput] = useState('')

  // Excel staging & verification states
  const [stagedImportType, setStagedImportType] = useState<'students' | 'subjects' | null>(null)
  const [stagedRows, setStagedRows] = useState<any[] | null>(null)
  const [importValidationReport, setImportValidationReport] = useState<any | null>(null)
  const [showImportPreviewModal, setShowImportPreviewModal] = useState(false)
  const [isSavingImport, setIsSavingImport] = useState(false)

  // Form states for student
  const [stIdCard, setStIdCard] = useState('')
  const [stTitle, setStTitle] = useState('เด็กชาย')
  const [stFirstName, setStFirstName] = useState('')
  const [stLastName, setStLastName] = useState('')
  const [stNumber, setStNumber] = useState(1)
  const [stRoomType, setStRoomType] = useState('Normal')

  // Form states for subject
  const [subCode, setSubCode] = useState('')
  const [subName, setSubName] = useState('')
  const [subCredits, setSubCredits] = useState(1.5)
  const [subGradeLevel, setSubGradeLevel] = useState(7)

  // Search & Filter states for Students
  const [searchStudentId, setSearchStudentId] = useState('')
  const [searchStudentName, setSearchStudentName] = useState('')
  const [searchStudentGrade, setSearchStudentGrade] = useState('all')
  const [searchStudentRoom, setSearchStudentRoom] = useState('all') // stores classroom_id or 'all'

  // Custom Excel Export Modal States
  const [showExportModal, setShowExportModal] = useState(false)
  const [exportSelectedSubject, setExportSelectedSubject] = useState('')
  const [cleanupClassroomId, setCleanupClassroomId] = useState('')
  const [selectedColumns, setSelectedColumns] = useState({
    studentCode: true,
    prefix: true,
    name: true,
    grade: true,
    room: true,
    no: true,
    roomType: true,
    status: true,
    scorePre: true,
    scorePost: true,
    gain: true,
    evaluation: true
  })

  // Search & Filter states for Subjects
  const [searchSubjectCode, setSearchSubjectCode] = useState('')
  const [searchSubjectName, setSearchSubjectName] = useState('')

  // Pagination states
  const [studentPage, setStudentPage] = useState(1)
  const [subjectPage, setSubjectPage] = useState(1)
  const itemsPerPage = 20 // Changed from 50 to 20

  // Manual sorting states
  const [studentSortBy, setStudentSortBy] = useState<string>('classroom')
  const [studentSortOrder, setStudentSortOrder] = useState<'asc' | 'desc'>('asc')
  const [subjectSortBy, setSubjectSortBy] = useState<string>('grade_level')
  const [subjectSortOrder, setSubjectSortOrder] = useState<'asc' | 'desc'>('asc')

  // Security Verification states
  const [showVerificationModal, setShowVerificationModal] = useState(false)
  const [verificationPIN, setVerificationPIN] = useState('')
  const [verificationPrompt, setVerificationPrompt] = useState('')
  const [verificationCallback, setVerificationCallback] = useState<any>(null)
  const [verificationError, setVerificationError] = useState('')

  // Subject Edit Modal state
  const [showEditSubjectModal, setShowEditSubjectModal] = useState<any | null>(null)

  // Separated Grade/Room states for Add/Edit Student
  const [stGrade, setStGrade] = useState<number>(7)
  const [stRoom, setStRoom] = useState<string>('1')
  const [editStGrade, setEditStGrade] = useState<number>(7)
  const [editStRoom, setEditStRoom] = useState<string>('1')

  // Bulk Classroom Edit states
  const [showBulkClassroomModal, setShowBulkClassroomModal] = useState(false)
  const [bulkSrcGrade, setBulkSrcGrade] = useState<string>('')
  const [bulkSrcRoom, setBulkSrcRoom] = useState<string>('')
  const [bulkDestGrade, setBulkDestGrade] = useState<string>('')
  const [bulkDestRoom, setBulkDestRoom] = useState<string>('')
  const [bulkDestRoomType, setBulkDestRoomType] = useState('Normal')
  const [bulkActionType, setBulkActionType] = useState<'move' | 'room_type'>('move')
  const [bulkScope, setBulkScope] = useState<'single' | 'multiple' | 'grade'>('single')
  const [bulkSelectedRooms, setBulkSelectedRooms] = useState<string[]>([])

  // Form states for assignment
  const [teachers, setTeachers] = useState<any[]>([])
  const [teachingAssignments, setTeachingAssignments] = useState<any[]>([])
  const [assignTeacherId, setAssignTeacherId] = useState('')
  const [assignSubjectId, setAssignSubjectId] = useState('')
  const [assignClassroomId, setAssignClassroomId] = useState('')

  // Edit assignment states
  const [showEditAssignmentModal, setShowEditAssignmentModal] = useState(false)
  const [editAssignId, setEditAssignId] = useState<number | null>(null)
  const [editAssignTeacherId, setEditAssignTeacherId] = useState('')
  const [editAssignSubjectId, setEditAssignSubjectId] = useState('')
  const [editAssignClassroomId, setEditAssignClassroomId] = useState('')

  // Collapse/expand state for teacher groups in assignments tab
  const [collapsedTeachers, setCollapsedTeachers] = useState<Set<string>>(new Set())

  // Classroom filter states for assignment modals
  const [assignClassroomFilterGrade, setAssignClassroomFilterGrade] = useState<string>('all')
  const [assignClassroomFilterRoom, setAssignClassroomFilterRoom] = useState<string>('')
  const [editAssignClassroomFilterGrade, setEditAssignClassroomFilterGrade] = useState<string>('all')
  const [editAssignClassroomFilterRoom, setEditAssignClassroomFilterRoom] = useState<string>('')

  // Academic years & import progress states
  const [academicYears, setAcademicYears] = useState<any[]>([])
  const [selectedYearId, setSelectedYearId] = useState<number>(1)
  const [importProgress, setImportProgress] = useState<{ current: number; total: number } | null>(null)

  const loadData = async () => {
    setLoading(true)
    try {
      const [allStudents, allSubjects, allClassrooms, allTypes, allProfiles, allAssignments, allDepts, allYears, allScores] = await Promise.all([
        dataService.getStudents(),
        dataService.getSubjects(),
        dataService.getClassrooms(),
        dataService.getClassroomTypes(),
        dataService.getProfiles(),
        dataService.getTeachingAssignments(),
        dataService.getDepartments(),
        dataService.getAcademicYears(),
        dataService.getScores()
      ])
      setStudents(allStudents)
      setSubjects(allSubjects)
      setClassrooms(allClassrooms)
      setRoomTypes(allTypes)
      setTeachers(allProfiles.filter((p: any) => p.role === 'teacher' || p.role === 'head_of_department' || p.role === 'admin'))
      setTeachingAssignments(allAssignments)
      setDepartments(allDepts)
      setAcademicYears(allYears)
      setScores(allScores)

      // Auto-cleanup classrooms if any room_number contains '/'
      const classroomsToFix = allClassrooms.filter((c: any) => c.room_number.includes('/'))
      if (classroomsToFix.length > 0) {
        for (const c of classroomsToFix) {
          const parts = c.room_number.split('/')
          const correctedRoom = parts[parts.length - 1]
          try {
            await dataService.updateClassroomRoomNumber(c.id, correctedRoom)
          } catch (e) {
            console.error('Failed to normalize classroom:', c.id, e)
          }
        }
        const updatedClassrooms = await dataService.getClassrooms()
        setClassrooms(updatedClassrooms)
      }

      // Auto-select active year
      const activeYear = allYears.find((y: any) => y.is_active)
      if (activeYear) {
        setSelectedYearId(activeYear.id)
      } else if (allYears.length > 0) {
        setSelectedYearId(allYears[0].id)
      }
    } catch (err) {
      console.error('Error loading academic data:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  // Filter students based on multi-field search inputs
  const filteredStudents = students.filter(st => {
    if (searchStudentId && !String(st.student_id_card).toLowerCase().includes(searchStudentId.toLowerCase())) {
      return false
    }
    const fullName = `${st.first_name || ''} ${st.last_name || ''}`.toLowerCase()
    if (searchStudentName && !fullName.includes(searchStudentName.toLowerCase())) {
      return false
    }
    if (searchStudentGrade !== 'all') {
      const targetGrade = Number(searchStudentGrade)
      const classroom = classrooms.find(c => c.id === st.classroom_id)
      if (!classroom || classroom.grade_level !== targetGrade) {
        return false
      }
    }
    if (searchStudentRoom !== 'all') {
      // filter by exact classroom_id to prevent cross-grade matches
      if (String(st.classroom_id) !== searchStudentRoom) {
        return false
      }
    }
    return true
  })

  // Sort students dynamically
  const sortedStudents = [...filteredStudents].sort((a, b) => {
    let valA: any = ''
    let valB: any = ''

    if (studentSortBy === 'student_id_card') {
      valA = a.student_id_card || ''
      valB = b.student_id_card || ''
    } else if (studentSortBy === 'name') {
      valA = `${a.first_name || ''} ${a.last_name || ''}`.toLowerCase()
      valB = `${b.first_name || ''} ${b.last_name || ''}`.toLowerCase()
    } else if (studentSortBy === 'number_in_class') {
      valA = Number(a.number_in_class || 0)
      valB = Number(b.number_in_class || 0)
    } else if (studentSortBy === 'classroom') {
      const classA = classrooms.find(c => c.id === a.classroom_id)
      const classB = classrooms.find(c => c.id === b.classroom_id)
      const gradeA = classA ? classA.grade_level : 0
      const gradeB = classB ? classB.grade_level : 0
      
      if (gradeA !== gradeB) {
        return studentSortOrder === 'asc' ? gradeA - gradeB : gradeB - gradeA
      }
      
      const roomA = classA ? parseInt(classA.room_number, 10) || 0 : 0
      const roomB = classB ? parseInt(classB.room_number, 10) || 0 : 0
      
      if (roomA !== roomB) {
        return studentSortOrder === 'asc' ? roomA - roomB : roomB - roomA
      }
      return (a.number_in_class || 0) - (b.number_in_class || 0)
    }

    if (valA < valB) return studentSortOrder === 'asc' ? -1 : 1
    if (valA > valB) return studentSortOrder === 'asc' ? 1 : -1
    return 0
  })

  // Pagination for students
  const totalStudentPages = Math.ceil(sortedStudents.length / itemsPerPage) || 1
  const paginatedStudents = sortedStudents.slice((studentPage - 1) * itemsPerPage, studentPage * itemsPerPage)

  // Filter subjects based on multi-field search inputs
  const filteredSubjects = subjects.filter(sub => {
    if (searchSubjectCode && !String(sub.code).toLowerCase().includes(searchSubjectCode.toLowerCase())) {
      return false
    }
    if (searchSubjectName && !String(sub.name).toLowerCase().includes(searchSubjectName.toLowerCase())) {
      return false
    }
    return true
  })

  // Sort subjects dynamically
  const sortedSubjects = [...filteredSubjects].sort((a, b) => {
    let valA: any = ''
    let valB: any = ''

    if (subjectSortBy === 'code') {
      valA = a.code || ''
      valB = b.code || ''
    } else if (subjectSortBy === 'name') {
      valA = a.name || ''
      valB = b.name || ''
    } else if (subjectSortBy === 'credits') {
      valA = Number(a.credits || 0)
      valB = Number(b.credits || 0)
    } else if (subjectSortBy === 'grade_level') {
      valA = Number(a.grade_level || 0)
      valB = Number(b.grade_level || 0)
    }

    if (valA < valB) return subjectSortOrder === 'asc' ? -1 : 1
    if (valA > valB) return subjectSortOrder === 'asc' ? 1 : -1
    return 0
  })

  // Pagination for subjects
  const totalSubjectPages = Math.ceil(sortedSubjects.length / itemsPerPage) || 1
  const paginatedSubjects = sortedSubjects.slice((subjectPage - 1) * itemsPerPage, subjectPage * itemsPerPage)

  useEffect(() => {
    setStudentPage(1)
  }, [searchStudentId, searchStudentName, searchStudentGrade, searchStudentRoom])

  useEffect(() => {
    setSubjectPage(1)
  }, [searchSubjectCode, searchSubjectName])

  const triggerSecureAction = (promptText: string, callback: () => void) => {
    setVerificationPrompt(promptText)
    setVerificationCallback(() => callback)
    setVerificationPIN('')
    setVerificationError('')
    setShowVerificationModal(true)
  }

  const handleVerifyPINSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (verificationPIN === 'admin1234') {
      setShowVerificationModal(false)
      if (verificationCallback) {
        verificationCallback()
      }
    } else {
      setVerificationError('⚠️ รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง (รหัสเริ่มต้น: admin1234)')
    }
  }

  // Assignment operations
  const handleAddAssignment = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!assignTeacherId || !assignSubjectId || !assignClassroomId) return
    try {
      await dataService.addAssignment(
        assignTeacherId,
        Number(assignSubjectId),
        Number(assignClassroomId),
        selectedYearId
      )
      setNotification({ type: 'success', message: '✏️ มอบหมายงานสอนใหม่เรียบร้อยแล้ว' })
      setShowAddAssignmentModal(false)
      setAssignTeacherId('')
      setAssignSubjectId('')
      setAssignClassroomId('')
      loadData()
    } catch (err: any) {
      setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาด' })
    }
  }

  const handleDeleteAssignment = async (id: number) => {
    if (window.confirm('ยืนยันยกเลิกการมอบหมายงานสอนนี้?')) {
      await dataService.deleteAssignment(id)
      setNotification({ type: 'success', message: '🗑️ ยกเลิกการมอบหมายงานสอนเรียบร้อยแล้ว' })
      loadData()
    }
  }

  const handleUpdateAssignment = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!editAssignId || !editAssignTeacherId || !editAssignSubjectId || !editAssignClassroomId) return
    try {
      await dataService.updateAssignment(
        editAssignId,
        editAssignTeacherId,
        Number(editAssignSubjectId),
        Number(editAssignClassroomId)
      )
      setNotification({ type: 'success', message: '✏️ อัปเดตการมอบหมายงานสอนเรียบร้อยแล้ว' })
      setShowEditAssignmentModal(false)
      setEditAssignId(null)
      loadData()
    } catch (err: any) {
      setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการแก้ไข' })
    }
  }

  const handleClearAllData = () => {
    triggerSecureAction('🔥 ยืนยันรหัสผ่านเพื่อล้างข้อมูลระบบทั้งหมด (นักเรียน วิชา คะแนน และห้องเรียน)', async () => {
      try {
        setLoading(true)
        await dataService.clearAllData()
        setNotification({ type: 'success', message: '💥 ล้างข้อมูลระบบทั้งหมดเรียบร้อยแล้ว' })
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการล้างข้อมูล' })
      } finally {
        setLoading(false)
      }
    })
  }

  const handleClearAllSubjects = () => {
    triggerSecureAction('🗑️ ยืนยันรหัสผ่านเพื่อล้างวิชาเรียนทั้งหมดในระบบ (รวมถึงงานมอบหมายสอนและคะแนน)', async () => {
      try {
        setLoading(true)
        await dataService.clearAllSubjects()
        setNotification({ type: 'success', message: '📚 ล้างข้อมูลวิชาเรียนทั้งหมดเรียบร้อยแล้ว' })
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการล้างข้อมูลวิชา' })
      } finally {
        setLoading(false)
      }
    })
  }

  const handleClearClassroomData = () => {
    if (!cleanupClassroomId) return
    const cid = Number(cleanupClassroomId)
    const classroom = classrooms.find(c => c.id === cid)
    const className = classroom ? `ม.${classroom.grade_level >= 7 ? classroom.grade_level - 6 : classroom.grade_level}/${classroom.room_number}` : ''
    triggerSecureAction(`❌ ยืนยันรหัสผ่านเพื่อลบข้อมูลห้องเรียน ${className} และคะแนน/นักเรียนในห้องเรียนนี้ทั้งหมด`, async () => {
      try {
        setLoading(true)
        await dataService.clearClassroomData(cid)
        setNotification({ type: 'success', message: `🏫 ลบข้อมูลห้องเรียน ${className} เรียบร้อยแล้ว` })
        setCleanupClassroomId('')
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการลบห้องเรียน' })
      } finally {
        setLoading(false)
      }
    })
  }

  // Student operations
  const handleAddStudent = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!stIdCard || !stFirstName || !stLastName) return
    triggerSecureAction('🎓 ยืนยันการป้อนรหัสผ่านเพื่อเพิ่มข้อมูลนักเรียนใหม่', async () => {
      try {
        let targetClassroom = classrooms.find(c => c.grade_level === stGrade && c.room_number === stRoom)
        if (!targetClassroom) {
          targetClassroom = await dataService.createClassroom(stGrade, stRoom)
          const updated = await dataService.getClassrooms()
          setClassrooms(updated)
        }

        await dataService.addStudent({
          student_id_card: stIdCard,
          title: stTitle,
          first_name: stFirstName,
          last_name: stLastName,
          classroom_id: targetClassroom.id,
          number_in_class: Number(stNumber),
          room_type: stRoomType
        })
        setNotification({ type: 'success', message: '🎓 เพิ่มข้อมูลนักเรียนรายบุคคลเรียบร้อยแล้ว' })
        setShowAddStudentModal(false)
        setStIdCard('')
        setStFirstName('')
        setStLastName('')
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการบันทึก' })
      }
    })
  }

  const handleUpdateStudent = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!showEditStudentModal) return
    triggerSecureAction('💾 ยืนยันการป้อนรหัสผ่านเพื่อบันทึกการแก้ไขข้อมูลนักเรียน', async () => {
      try {
        let targetClassroom = classrooms.find(c => c.grade_level === editStGrade && c.room_number === editStRoom)
        if (!targetClassroom) {
          targetClassroom = await dataService.createClassroom(editStGrade, editStRoom)
          const updated = await dataService.getClassrooms()
          setClassrooms(updated)
        }

        await dataService.updateStudent(showEditStudentModal.id, {
          student_id_card: showEditStudentModal.student_id_card,
          title: showEditStudentModal.title,
          first_name: showEditStudentModal.first_name,
          last_name: showEditStudentModal.last_name,
          classroom_id: targetClassroom.id,
          number_in_class: Number(showEditStudentModal.number_in_class),
          room_type: showEditStudentModal.room_type,
          status: showEditStudentModal.status
        })
        setNotification({ type: 'success', message: '💾 ปรับปรุงข้อมูลนักเรียนเรียบร้อยแล้ว' })
        setShowEditStudentModal(null)
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการปรับปรุงข้อมูล' })
      }
    })
  }

  const handleDeleteStudent = async (id: number) => {
    triggerSecureAction('🗑️ ยืนยันการป้อนรหัสผ่านเพื่อลบประวัตินักเรียนอย่างถาวร', async () => {
      try {
        await dataService.deleteStudent(id)
        setNotification({ type: 'success', message: '🗑️ ลบประวัตินักเรียนเรียบร้อยแล้ว' })
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการลบ' })
      }
    })
  }

  // Subject operations
  const handleAddSubject = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!subCode || !subName) return
    triggerSecureAction('📚 ยืนยันการป้อนรหัสผ่านเพื่อเพิ่มรายวิชาเรียนใหม่', async () => {
      try {
        await dataService.createSubject(subCode, subName, 1, 10, 10) // default deptId 1
        setNotification({ type: 'success', message: '📚 เพิ่มรายวิชาเรียนใหม่เรียบร้อยแล้ว' })
        setShowAddSubjectModal(false)
        setSubCode('')
        setSubName('')
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการบันทึกรายวิชา' })
      }
    })
  }

  const handleDeleteSubject = async (id: number) => {
    triggerSecureAction('🗑️ ยืนยันการป้อนรหัสผ่านเพื่อลบวิชาเรียนออกจากระบบอย่างถาวร', async () => {
      try {
        await dataService.deleteSubject(id)
        setNotification({ type: 'success', message: '🗑️ ลบวิชาเรียนออกจากระบบเรียบร้อยแล้ว' })
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการลบรายวิชา' })
      }
    })
  }

  const handleUpdateSubject = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!showEditSubjectModal) return
    triggerSecureAction('💾 ยืนยันการป้อนรหัสผ่านเพื่อบันทึกการแก้ไขข้อมูลรายวิชา', async () => {
      try {
        await dataService.updateSubject(showEditSubjectModal.id, {
          code: showEditSubjectModal.code.trim(),
          name: showEditSubjectModal.name.trim(),
          credits: Number(showEditSubjectModal.credits || 1.5),
          grade_level: Number(showEditSubjectModal.grade_level || 7),
          department_id: Number(showEditSubjectModal.department_id || 1)
        })
        setNotification({ type: 'success', message: '💾 ปรับปรุงข้อมูลรายวิชาเรียบร้อยแล้ว' })
        setShowEditSubjectModal(null)
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการแก้ไข' })
      }
    })
  }

  const handleBulkClassroomEdit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!bulkSrcGrade) {
      setNotification({ type: 'error', message: 'กรุณาเลือกชั้นเรียนต้นทาง' })
      return
    }

    let targetStudentIds: number[] = []
    let sourceRoomNamesDisplay = ''

    if (bulkScope === 'single') {
      if (!bulkSrcRoom) {
        setNotification({ type: 'error', message: 'กรุณาเลือกห้องเรียนต้นทาง' })
        return
      }
      const srcClassroom = classrooms.find(c => c.grade_level === Number(bulkSrcGrade) && c.room_number === bulkSrcRoom)
      if (!srcClassroom) {
        setNotification({ type: 'error', message: 'ไม่พบห้องเรียนต้นทางที่เลือก' })
        return
      }
      targetStudentIds = students.filter(s => s.classroom_id === srcClassroom.id).map(s => s.id)
      const displaySrcGrade = Number(bulkSrcGrade) >= 7 ? Number(bulkSrcGrade) - 6 : bulkSrcGrade
      sourceRoomNamesDisplay = `ม.${displaySrcGrade}/${bulkSrcRoom}`
    } else if (bulkScope === 'multiple') {
      if (bulkSelectedRooms.length === 0) {
        setNotification({ type: 'error', message: 'กรุณาเลือกอย่างน้อยหนึ่งห้องเรียน' })
        return
      }
      const srcClassrooms = classrooms.filter(c => c.grade_level === Number(bulkSrcGrade) && bulkSelectedRooms.includes(c.room_number))
      const srcClassroomIds = srcClassrooms.map(c => c.id)
      targetStudentIds = students.filter(s => srcClassroomIds.includes(s.classroom_id)).map(s => s.id)
      const displaySrcGrade = Number(bulkSrcGrade) >= 7 ? Number(bulkSrcGrade) - 6 : bulkSrcGrade
      sourceRoomNamesDisplay = `ม.${displaySrcGrade}/[ห้อง ${bulkSelectedRooms.join(', ')}]`
    } else if (bulkScope === 'grade') {
      const srcClassrooms = classrooms.filter(c => c.grade_level === Number(bulkSrcGrade))
      const srcClassroomIds = srcClassrooms.map(c => c.id)
      targetStudentIds = students.filter(s => srcClassroomIds.includes(s.classroom_id)).map(s => s.id)
      const displaySrcGrade = Number(bulkSrcGrade) >= 7 ? Number(bulkSrcGrade) - 6 : bulkSrcGrade
      sourceRoomNamesDisplay = `ม.${displaySrcGrade} ทุกห้องเรียน`
    }

    if (targetStudentIds.length === 0) {
      setNotification({ type: 'error', message: 'ไม่พบนักเรียนในห้องเรียนต้นทางที่เลือก' })
      return
    }

    triggerSecureAction('🚀 ยืนยันการป้อนรหัสผ่านเพื่อดำเนินการจัดการแบบกลุ่ม', async () => {
      try {
        if (bulkActionType === 'move') {
          if (bulkScope === 'grade') {
            if (!bulkDestGrade) {
              throw new Error('กรุณาเลือกชั้นเรียนปลายทาง')
            }
            if (bulkSrcGrade === bulkDestGrade) {
              throw new Error('ระดับชั้นเรียนต้นทางและปลายทางต้องไม่เป็นชั้นเดียวกัน')
            }

            // Grade-wide parallel promotion
            let totalMoved = 0
            const srcClassrooms = classrooms.filter(c => c.grade_level === Number(bulkSrcGrade))
            
            for (const srcClass of srcClassrooms) {
              const srcStudents = students.filter(s => s.classroom_id === srcClass.id)
              if (srcStudents.length === 0) continue

              let destClass = classrooms.find(c => c.grade_level === Number(bulkDestGrade) && c.room_number === srcClass.room_number)
              if (!destClass) {
                destClass = await dataService.createClassroom(Number(bulkDestGrade), srcClass.room_number)
                const updated = await dataService.getClassrooms()
                setClassrooms(updated)
              }

              const idsToMove = srcStudents.map(s => s.id)
              await dataService.bulkUpdateStudentsClassroom(idsToMove, destClass.id)
              totalMoved += idsToMove.length
            }

            const displaySrcGrade = Number(bulkSrcGrade) >= 7 ? Number(bulkSrcGrade) - 6 : bulkSrcGrade
            const displayDestGrade = Number(bulkDestGrade) >= 7 ? Number(bulkDestGrade) - 6 : bulkDestGrade
            setNotification({ type: 'success', message: `🚀 เลื่อนชั้นเรียนระดับ ม.${displaySrcGrade} ทั้งหมด ไปยัง ม.${displayDestGrade} สำเร็จ (รวม ${totalMoved} คน)` })
          } else {
            // single or multiple source rooms moving to one destination room
            if (!bulkDestGrade || !bulkDestRoom) {
              throw new Error('กรุณาเลือกชั้นและห้องเรียนปลายทาง')
            }
            if (bulkScope === 'single' && bulkSrcGrade === bulkDestGrade && bulkSrcRoom === bulkDestRoom) {
              throw new Error('ห้องเรียนต้นทางและปลายทางต้องไม่เป็นห้องเดียวกัน')
            }

            let destClassroom = classrooms.find(c => c.grade_level === Number(bulkDestGrade) && c.room_number === bulkDestRoom)
            if (!destClassroom) {
              destClassroom = await dataService.createClassroom(Number(bulkDestGrade), bulkDestRoom)
              const updated = await dataService.getClassrooms()
              setClassrooms(updated)
            }

            await dataService.bulkUpdateStudentsClassroom(targetStudentIds, destClassroom.id)
            setNotification({ type: 'success', message: `🚀 ย้ายนักเรียนจาก ${sourceRoomNamesDisplay} จำนวน ${targetStudentIds.length} คน ไปยังห้องเรียนใหม่สำเร็จ` })
          }
        } else if (bulkActionType === 'room_type') {
          if (!bulkDestRoomType) {
            throw new Error('กรุณาเลือกประเภทห้องเรียนที่ต้องการเปลี่ยน')
          }
          await dataService.bulkUpdateStudentsRoomType(targetStudentIds, bulkDestRoomType)
          setNotification({ type: 'success', message: `🚀 เปลี่ยนประเภทห้องเรียนนักเรียนจาก ${sourceRoomNamesDisplay} จำนวน ${targetStudentIds.length} คน เป็น "${bulkDestRoomType}" สำเร็จ` })
        }
        
        setShowBulkClassroomModal(false)
        setBulkSrcGrade('')
        setBulkSrcRoom('')
        setBulkDestGrade('')
        setBulkDestRoom('')
        setBulkSelectedRooms([])
        setBulkScope('single')
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการดำเนินการแบบกลุ่ม' })
      }
    })
  }

  // Room type operations
  const handleAddRoomType = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!newRoomTypeVal) return
    try {
      await dataService.createClassroomType(newRoomTypeVal)
      setNotification({ type: 'success', message: `➕ เพิ่มประเภทห้องเรียน "${newRoomTypeVal}" แล้ว` })
      setNewRoomTypeVal('')
      setShowRoomTypeModal(false)
      loadData()
    } catch (err: any) {
      setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการบันทึก' })
    }
  }

  const handleDeleteRoomType = async (typeName: string) => {
    if (window.confirm(`ยืนยันลบประเภทห้องเรียน "${typeName}"?`)) {
      try {
        await dataService.deleteClassroomType(typeName)
        setNotification({ type: 'success', message: `🗑️ ลบประเภทห้องเรียน "${typeName}" เรียบร้อยแล้ว` })
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาด' })
      }
    }
  }

  // Department operations
  const handleAddDepartment = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!newDeptNameVal) return
    try {
      await dataService.createDepartment(newDeptNameVal)
      setNotification({ type: 'success', message: `🏫 เพิ่มกลุ่มสาระฯ "${newDeptNameVal}" สำเร็จ` })
      setNewDeptNameVal('')
      loadData()
    } catch (err: any) {
      setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาด' })
    }
  }

  const handleDeleteDepartment = async (id: number) => {
    if (window.confirm('ยืนยันการลบกลุ่มสาระการเรียนรู้นี้?')) {
      try {
        await dataService.deleteDepartment(id)
        setNotification({ type: 'success', message: '🗑️ ลบกลุ่มสาระฯ เรียบร้อยแล้ว' })
        loadData()
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาด' })
      }
    }
  }

  const handleSaveEditDept = async (id: number) => {
    if (!editingDeptVal.trim()) return
    try {
      await dataService.updateDepartment(id, editingDeptVal)
      setNotification({ type: 'success', message: '💾 แก้ไขชื่อกลุ่มสาระเรียบร้อยแล้ว' })
      setEditingDeptId(null)
      loadData()
    } catch (err: any) {
      setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการบันทึก' })
    }
  }

  const handleSaveEditRoomType = async (oldName: string) => {
    if (!editingRoomTypeInput.trim()) return
    try {
      await dataService.updateClassroomType(oldName, editingRoomTypeInput)
      setNotification({ type: 'success', message: '💾 แก้ไขชื่อประเภทห้องเรียนเรียบร้อยแล้ว' })
      setEditingRoomTypeVal(null)
      loadData()
    } catch (err: any) {
      setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการบันทึก' })
    }
  }

  const handleExportCustomExcel = () => {
    try {
      const headers: string[] = []
      if (selectedColumns.studentCode) headers.push('รหัสนักเรียน')
      if (selectedColumns.prefix) headers.push('คำนำหน้า')
      if (selectedColumns.name) headers.push('ชื่อ-นามสกุล')
      if (selectedColumns.grade) headers.push('ระดับชั้น')
      if (selectedColumns.room) headers.push('ห้องเรียน')
      if (selectedColumns.no) headers.push('เลขที่')
      if (selectedColumns.roomType) headers.push('ประเภทห้อง')
      if (selectedColumns.status) headers.push('สถานะ')
      
      const subId = exportSelectedSubject ? Number(exportSelectedSubject) : null
      const targetSub = subId ? subjects.find(s => s.id === subId) : null
      const subCode = targetSub ? targetSub.code : 'ทั้งหมด'

      if (subId) {
        if (selectedColumns.scorePre) headers.push(`คะแนน Pre-Test (${subCode})`)
        if (selectedColumns.scorePost) headers.push(`คะแนน Post-Test (${subCode})`)
        if (selectedColumns.gain) headers.push(`พัฒนาการ Gain (${subCode})`)
        if (selectedColumns.evaluation) headers.push(`ผลการประเมิน (${subCode})`)
      } else {
        if (selectedColumns.scorePre) headers.push('คะแนน Pre-Test เฉลี่ย (ทุกวิชา)')
        if (selectedColumns.scorePost) headers.push('คะแนน Post-Test เฉลี่ย (ทุกวิชา)')
        if (selectedColumns.gain) headers.push('พัฒนาการ Gain เฉลี่ย (ทุกวิชา)')
      }

      const rows = sortedStudents.map((st, idx) => {
        const row: any[] = []
        
        let preVal: number | null = null
        let postVal: number | null = null
        let gainVal: number | null = null
        let evalStr = '—'

        if (subId) {
          const sc = scores.find((s: any) => s.student_id === st.id && s.subject_id === subId)
          if (sc) {
            preVal = sc.pre_test_score !== null && sc.pre_test_score !== undefined ? Number(sc.pre_test_score) : null
            postVal = sc.post_test_score !== null && sc.post_test_score !== undefined ? Number(sc.post_test_score) : null
            gainVal = (preVal !== null && postVal !== null) ? (postVal - preVal) : null
            const maxPost = targetSub?.max_score_post || 10
            const postPercent = postVal !== null ? (postVal / maxPost) * 100 : null
            if (postPercent !== null) {
              evalStr = postPercent >= 50 ? 'ผ่านเกณฑ์ (50%)' : 'ไม่ผ่านเกณฑ์'
            }
          }
        } else {
          // Average across all subjects
          const stScores = scores.filter((s: any) => s.student_id === st.id)
          let preSum = 0, preCount = 0
          let postSum = 0, postCount = 0
          stScores.forEach((sc: any) => {
            if (sc.pre_test_score !== null && sc.pre_test_score !== undefined) {
              preSum += Number(sc.pre_test_score)
              preCount++
            }
            if (sc.post_test_score !== null && sc.post_test_score !== undefined) {
              postSum += Number(sc.post_test_score)
              postCount++
            }
          })
          preVal = preCount > 0 ? preSum / preCount : null
          postVal = postCount > 0 ? postSum / postCount : null
          gainVal = (preVal !== null && postVal !== null) ? (postVal - preVal) : null
        }

        const classroom = classrooms.find(c => c.id === st.classroom_id)
        const gradeStr = classroom ? (classroom.grade_level >= 7 ? `ม.${classroom.grade_level - 6}` : `ม.${classroom.grade_level}`) : '—'
        const roomStr = classroom ? classroom.room_number : '—'
        const statusStr = st.status === 'resigned' ? 'ลาออก' : st.status === 'transferred' ? 'ย้ายห้อง' : 'ปกติ'

        if (selectedColumns.studentCode) row.push(st.student_id_card || '')
        if (selectedColumns.prefix) row.push(st.title || '')
        if (selectedColumns.name) row.push(`${st.first_name || ''} ${st.last_name || ''}`)
        if (selectedColumns.grade) row.push(gradeStr)
        if (selectedColumns.room) row.push(roomStr)
        if (selectedColumns.no) row.push(st.no || idx + 1)
        if (selectedColumns.roomType) row.push(st.room_type || '')
        if (selectedColumns.status) row.push(statusStr)

        if (subId) {
          if (selectedColumns.scorePre) row.push(preVal !== null ? Number(preVal.toFixed(1)) : '')
          if (selectedColumns.scorePost) row.push(postVal !== null ? Number(postVal.toFixed(1)) : '')
          if (selectedColumns.gain) row.push(gainVal !== null ? Number(gainVal.toFixed(1)) : '')
          if (selectedColumns.evaluation) row.push(evalStr)
        } else {
          if (selectedColumns.scorePre) row.push(preVal !== null ? Number(preVal.toFixed(1)) : '')
          if (selectedColumns.scorePost) row.push(postVal !== null ? Number(postVal.toFixed(1)) : '')
          if (selectedColumns.gain) row.push(gainVal !== null ? Number(gainVal.toFixed(1)) : '')
        }

        return row
      })

      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'รายงานข้อมูลนักเรียน')
      
      const fileName = subId 
        ? `รายงานนักเรียน_วิชา_${subCode}_กำหนดคอลัมน์.xlsx` 
        : `รายงานนักเรียน_สถิติเฉลี่ยทุกวิชา_กำหนดคอลัมน์.xlsx`
      XLSX.writeFile(wb, fileName)
      
      setShowExportModal(false)
      setNotification({ type: 'success', message: '📥 ส่งออกไฟล์ Excel (.xlsx) สำเร็จเรียบร้อยแล้ว' })
      setTimeout(() => setNotification(null), 3000)
    } catch (err) {
      setNotification({ type: 'error', message: 'เกิดข้อผิดพลาดในการส่งออกรายงาน Excel' })
    }
  }

  const downloadStudentExcelSample = () => {
    try {
      const headers = [
        ['รหัสนักเรียน', 'คำนำหน้า', 'ชื่อ', 'นามสกุล', 'ระดับชั้นและห้อง', 'เลขที่', 'ประเภทห้อง']
      ]
      const rows = [
        ['10001', 'นาย', 'สมชาย', 'ใจดี', '1/1', '1', 'Normal'],
        ['10002', 'นางสาว', 'สมศรี', 'มีสุข', '1/1', '2', 'Gifted'],
        ['20001', 'นาย', 'วิชัย', 'เก่งกล้า', '2/1', '1', 'EP']
      ]
      const ws = XLSX.utils.aoa_to_sheet([...headers, ...rows])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'รายชื่อนักเรียน')
      XLSX.writeFile(wb, 'student_sample.xlsx')
      setNotification({ type: 'success', message: '📥 ดาวน์โหลดไฟล์ตัวอย่างนักเรียนเรียบร้อยแล้ว' })
    } catch (err: any) {
      setNotification({ type: 'error', message: 'ไม่สามารถสร้างไฟล์ตัวอย่างได้' })
    }
  }

  const downloadSubjectExcelSample = () => {
    try {
      const headers = [
        ['รหัสวิชา', 'ชื่อวิชา', 'หน่วยกิต', 'ระดับชั้น']
      ]
      const rows = [
        ['ค21101', 'คณิตศาสตร์พื้นฐาน', '1.5', '7'],
        ['ว21101', 'วิทยาศาสตร์พื้นฐาน', '1.5', '7'],
        ['ท22101', 'ภาษาไทยพื้นฐาน', '1.5', '8']
      ]
      const ws = XLSX.utils.aoa_to_sheet([...headers, ...rows])
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'รายวิชาเรียน')
      XLSX.writeFile(wb, 'subject_sample.xlsx')
      setNotification({ type: 'success', message: '📥 ดาวน์โหลดไฟล์ตัวอย่างวิชาเรียนเรียบร้อยแล้ว' })
    } catch (err: any) {
      setNotification({ type: 'error', message: 'ไม่สามารถสร้างไฟล์ตัวอย่างได้' })
    }
  }

  // Excel Upload Custom Structure:
  // รหัสนักเรียน, คำนำหน้า, ชื่อ, นามสกุล, ระดับชั้นและห้อง, เลขที่, ประเภทห้อง
  const handleExcelImportStudents = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = async (evt) => {
      try {
        const bstr = evt.target?.result
        const wb = XLSX.read(bstr, { type: 'binary' })
        const wsname = wb.SheetNames[0]
        const ws = wb.Sheets[wsname]
        const rawData = XLSX.utils.sheet_to_json(ws) as any[]

        if (rawData.length === 0) {
          throw new Error('ไม่พบข้อมูลนักเรียนในไฟล์ Excel')
        }

        const seenCards = new Set<string>()
        const processed = rawData.map((row, index) => {
          const studentIdCard = String(row.student_id_card || row['รหัสนักเรียน'] || row['รหัสประจำตัว'] || '').trim()
          const title = String(row.title || row['คำนำหน้า'] || 'เด็กชาย').trim()
          const firstName = String(row.first_name || row['ชื่อ'] || row['ชื่อจริง'] || '').trim()
          const lastName = String(row.last_name || row['นามสกุล'] || '').trim()
          let gradeAndRoom = String(row.grade_and_room || row['ระดับชั้นและห้อง'] || row['ห้องเรียน'] || '').trim()
          const numberInClass = Number(row.number || row['เลขที่'] || 1)
          const roomType = String(row.room_type || row['ประเภทห้อง'] || 'Normal').trim()

          // Clean "ม." prefix
          let cleanStr = gradeAndRoom.replace(/\s+/g, '')
          if (cleanStr.startsWith('ม.')) {
            cleanStr = cleanStr.substring(2)
          } else if (cleanStr.startsWith('ม')) {
            cleanStr = cleanStr.substring(1)
          }
          gradeAndRoom = cleanStr

          // Validation checks
          const missingFields = []
          if (!studentIdCard) missingFields.push('รหัสนักเรียน')
          if (!firstName) missingFields.push('ชื่อ')
          if (!lastName) missingFields.push('นามสกุล')
          if (!gradeAndRoom) missingFields.push('ระดับชั้นและห้อง')

          if (missingFields.length > 0) {
            return {
              id: index,
              data: { student_id_card: studentIdCard, title, first_name: firstName, last_name: lastName, grade_and_room: gradeAndRoom, number_in_class: numberInClass, room_type: roomType },
              status: 'error',
              errorMsg: `ขาดข้อมูลสำคัญ: ${missingFields.join(', ')}`
            }
          }

          // Check duplicate in the uploaded file itself
          if (seenCards.has(studentIdCard)) {
            return {
              id: index,
              data: { student_id_card: studentIdCard, title, first_name: firstName, last_name: lastName, grade_and_room: gradeAndRoom, number_in_class: numberInClass, room_type: roomType },
              status: 'duplicate',
              errorMsg: `ข้อมูลซ้ำซ้อนภายในไฟล์อัปโหลดนี้ (จะถูกข้าม)`
            }
          }
          seenCards.add(studentIdCard)

          // Check duplicate/update in database (detailed diff check)
          const existing = students.find(s => String(s.student_id_card).trim() === studentIdCard)
          if (existing) {
            // Parse grade/room to correctly find the classroom (must match both grade AND room)
            const parsedGradeRoom = (() => {
              let cleanStr = gradeAndRoom.replace(/\s+/g, '')
              if (cleanStr.startsWith('ม.')) cleanStr = cleanStr.substring(2)
              else if (cleanStr.startsWith('ม')) cleanStr = cleanStr.substring(1)
              const parts = cleanStr.split('/')
              if (parts.length >= 2) {
                let g = parseInt(parts[0], 10)
                if (g >= 1 && g <= 6) g = g + 6
                return { grade: g, room: parts[1] }
              }
              return { grade: 7, room: cleanStr }
            })()
            const classroomObj = classrooms.find((c: any) =>
              c.grade_level === parsedGradeRoom.grade && c.room_number === parsedGradeRoom.room
            )
            const isDifferent =
              existing.first_name !== firstName ||
              existing.last_name !== lastName ||
              existing.title !== title ||
              (!classroomObj || existing.classroom_id !== classroomObj.id) ||
              Number(existing.number_in_class) !== Number(numberInClass) ||
              existing.room_type !== roomType;

            if (isDifferent) {
              return {
                id: index,
                data: { id: existing.id, student_id_card: studentIdCard, title, first_name: firstName, last_name: lastName, grade_and_room: gradeAndRoom, number_in_class: numberInClass, room_type: roomType },
                status: 'update',
                errorMsg: `ข้อมูลบางส่วนต่างจากระบบ (จะทำการอัปเดตข้อมูลเดิม)`
              }
            } else {
              return {
                id: index,
                data: { student_id_card: studentIdCard, title, first_name: firstName, last_name: lastName, grade_and_room: gradeAndRoom, number_in_class: numberInClass, room_type: roomType },
                status: 'duplicate',
                errorMsg: `ข้อมูลตรงกันทุกประการกับในระบบแล้ว (จะถูกข้าม)`
              }
            }
          }

          return {
            id: index,
            data: { student_id_card: studentIdCard, title, first_name: firstName, last_name: lastName, grade_and_room: gradeAndRoom, number_in_class: numberInClass, room_type: roomType },
            status: 'valid'
          }
        })

        // Identify new classrooms and new room types to be created
        const newRoomsSet = new Set<string>()
        const newRoomTypesSet = new Set<string>()
        processed.forEach(item => {
          if (item.status !== 'error') {
            const gr = item.data.grade_and_room  // already cleaned e.g. "1/1"
            const rt = item.data.room_type

            // Parse grade+room to check existence correctly
            const parsedGR = (() => {
              let cleanStr = gr.replace(/\s+/g, '')
              if (cleanStr.startsWith('ม.')) cleanStr = cleanStr.substring(2)
              else if (cleanStr.startsWith('ม')) cleanStr = cleanStr.substring(1)
              const parts = cleanStr.split('/')
              if (parts.length >= 2) {
                let g = parseInt(parts[0], 10)
                if (g >= 1 && g <= 6) g = g + 6
                return { grade: g, room: parts[1] }
              }
              return { grade: 7, room: cleanStr }
            })()

            // Check classroom existence by both grade_level AND room_number
            const exists = classrooms.some((c: any) =>
              c.grade_level === parsedGR.grade && c.room_number === parsedGR.room
            )
            if (!exists) {
              const displayGrade = parsedGR.grade >= 7 ? parsedGR.grade - 6 : parsedGR.grade
              newRoomsSet.add(`ม.${displayGrade}/${parsedGR.room}`)
            }

            // Check room type existence
            if (rt) {
              const existsType = roomTypes.some((t: string) => t.toLowerCase() === rt.toLowerCase())
              if (!existsType) {
                newRoomTypesSet.add(rt)
              }
            }
          }
        })

        const total = processed.length
        const valid = processed.filter(p => p.status === 'valid').length
        const update = processed.filter(p => p.status === 'update').length
        const duplicate = processed.filter(p => p.status === 'duplicate').length
        const error = processed.filter(p => p.status === 'error').length

        setStagedImportType('students')
        setStagedRows(processed)
        setImportValidationReport({
          total,
          valid,
          update,
          duplicate,
          error,
          newClassrooms: Array.from(newRoomsSet),
          newRoomTypes: Array.from(newRoomTypesSet)
        })
        setShowImportPreviewModal(true)
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'การประมวลผลไฟล์ Excel ผิดพลาด' })
      }
      e.target.value = ''
    }
    reader.readAsBinaryString(file)
  }

  // Excel Upload Subject Custom Structure:
  // รหัสวิชา, ชื่อวิชา, หน่วยกิต, ระดับชั้น
  const handleExcelImportSubjects = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = async (evt) => {
      try {
        const bstr = evt.target?.result
        const wb = XLSX.read(bstr, { type: 'binary' })
        const wsname = wb.SheetNames[0]
        const ws = wb.Sheets[wsname]
        const rawData = XLSX.utils.sheet_to_json(ws) as any[]

        if (rawData.length === 0) {
          throw new Error('ไม่พบข้อมูลรายวิชาในไฟล์ Excel')
        }

        const seenCodes = new Set<string>()
        const processed = rawData.map((row, index) => {
          const normalizeStr = (str: any) => String(str || '').trim().replace(/\s+/g, ' ')
          
          const code = normalizeStr(row.code || row['รหัสวิชา'] || '')
          const name = normalizeStr(row.name || row['ชื่อวิชา'] || '')
          const credits = Number(row.credits || row['หน่วยกิต'] || 1.5)

          const rawDept = normalizeStr(row['กลุ่มสาระ'] || row['กลุ่มสาระการเรียนรู้'] || row.department || '')
          let deptId = 1 // Default
          if (rawDept) {
            const matchedDept = departments.find(d => {
              const dName = normalizeStr(d.name).toLowerCase()
              const rDept = rawDept.toLowerCase()
              return dName === rDept || rDept.includes(dName) || dName.includes(rDept)
            })
            if (matchedDept) {
              deptId = matchedDept.id
            }
          }

          let rawGrade = row.grade_level || row['ระดับชั้น'] || 7
          let gradeLevel = 7
          if (rawGrade) {
            let str = String(rawGrade).replace(/\s+/g, '')
            if (str.includes('ต้น')) {
              gradeLevel = 20
            } else if (str.includes('ปลาย')) {
              gradeLevel = 30
            } else {
              const match = str.match(/\d+/)
              if (match) {
                let num = parseInt(match[0], 10)
                if (num >= 1 && num <= 6) {
                  gradeLevel = num + 6
                } else {
                  gradeLevel = num
                }
              }
            }
          }

          const missingFields = []
          if (!code) missingFields.push('รหัสวิชา')
          if (!name) missingFields.push('ชื่อวิชา')

          // Resolve department name and ID
          const finalDeptName = rawDept || (departments[0]?.name || 'ทั่วไป')

          if (missingFields.length > 0) {
            return {
              id: index,
              data: { code, name, credits, grade_level: gradeLevel, department_id: deptId, department_name: finalDeptName },
              status: 'error',
              errorMsg: `ขาดข้อมูลสำคัญ: ${missingFields.join(', ')}`
            }
          }

          // Check duplicate in the uploaded file itself
          if (seenCodes.has(code)) {
            return {
              id: index,
              data: { code, name, credits, grade_level: gradeLevel, department_id: deptId, department_name: finalDeptName },
              status: 'duplicate',
              errorMsg: `ข้อมูลซ้ำซ้อนภายในไฟล์อัปโหลดนี้ (จะถูกข้าม)`
            }
          }
          seenCodes.add(code)

          // Check duplicate/update in database (detailed diff check with whitespace normalization and name-based dept comparison)
          const existing = subjects.find(s => normalizeStr(s.code) === code)
          if (existing) {
            const existingDeptObj = departments.find(d => d.id === existing.department_id)
            const existingDeptName = existingDeptObj ? existingDeptObj.name : ''
            
            const isDifferent =
              normalizeStr(existing.name) !== name ||
              Number(existing.credits) !== Number(credits) ||
              Number(existing.grade_level) !== Number(gradeLevel) ||
              normalizeStr(existingDeptName).toLowerCase() !== finalDeptName.toLowerCase();

            if (isDifferent) {
              return {
                id: index,
                data: { id: existing.id, code, name, credits, grade_level: gradeLevel, department_id: deptId, department_name: finalDeptName },
                status: 'update',
                errorMsg: `ข้อมูลวิชาในไฟล์ต่างจากระบบ (จะทำการอัปเดตข้อมูลเดิม)`
              }
            } else {
              return {
                id: index,
                data: { code, name, credits, grade_level: gradeLevel, department_id: existing.department_id, department_name: existingDeptName },
                status: 'duplicate',
                errorMsg: `ข้อมูลตรงกันทุกประการกับในระบบแล้ว (จะถูกข้าม)`
              }
            }
          }

          return {
            id: index,
            data: { code, name, credits, grade_level: gradeLevel, department_id: deptId, department_name: finalDeptName },
            status: 'valid'
          }
        })

        const total = processed.length
        const valid = processed.filter(p => p.status === 'valid').length
        const update = processed.filter(p => p.status === 'update').length
        const duplicate = processed.filter(p => p.status === 'duplicate').length
        const error = processed.filter(p => p.status === 'error').length

        setStagedImportType('subjects')
        setStagedRows(processed)
        setImportValidationReport({
          total,
          valid,
          update,
          duplicate,
          error,
          newClassrooms: []
        })
        setShowImportPreviewModal(true)
      } catch (err: any) {
        setNotification({ type: 'error', message: err.message || 'การประมวลผลไฟล์ Excel ผิดพลาด' })
      }
      e.target.value = ''
    }
    reader.readAsBinaryString(file)
  }

  const executeConfirmImport = async () => {
    if (!stagedRows || !stagedImportType) return
    setIsSavingImport(true)
    try {
      const validItems = stagedRows.filter(r => r.status === 'valid' || r.status === 'update').map(r => r.data)
      if (validItems.length === 0) {
        setNotification({ type: 'error', message: 'ไม่มีข้อมูลใหม่หรือข้อมูลที่จะอัปเดตในการนำเข้าเลย' })
        setIsSavingImport(false)
        return
      }

      const total = validItems.length
      setImportProgress({ current: 0, total })
      const chunkSize = 50
      let importedCount = 0

      if (stagedImportType === 'students') {
        for (let i = 0; i < total; i += chunkSize) {
          const chunk = validItems.slice(i, i + chunkSize)
          const count = await dataService.importStudentsExcelComplete(chunk)
          importedCount += count
          setImportProgress({ current: Math.min(i + chunkSize, total), total })
        }
        setNotification({ type: 'success', message: `📊 นำเข้ารายชื่อนักเรียนเสร็จสิ้น จำนวน ${importedCount} คน` })
      } else {
        for (let i = 0; i < total; i += chunkSize) {
          const chunk = validItems.slice(i, i + chunkSize)
          const count = await dataService.importSubjectsExcel(chunk)
          importedCount += count
          setImportProgress({ current: Math.min(i + chunkSize, total), total })
        }
        setNotification({ type: 'success', message: `📚 นำเข้ารายการวิชาเรียนสำเร็จเสร็จสิ้น จำนวน ${importedCount} วิชา` })
      }

      setShowImportPreviewModal(false)
      setStagedImportType(null)
      setStagedRows(null)
      setImportValidationReport(null)
      setImportProgress(null)
      loadData()
    } catch (err: any) {
      setNotification({ type: 'error', message: err.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล' })
      setImportProgress(null)
    } finally {
      setIsSavingImport(false)
    }
  }



  const getClassroomStr = (classroomId: number) => {
    const c = classrooms.find(cl => cl.id === classroomId)
    if (!c) return '—'
    if (c.room_number.includes('/')) {
      return `ม.${c.room_number}`
    }
    const displayGrade = c.grade_level >= 7 ? c.grade_level - 6 : c.grade_level
    return `ม.${displayGrade}/${c.room_number}`
  }

  const getSubjectGradeStr = (gradeLevel: number) => {
    if (!gradeLevel) return '—'
    if (gradeLevel === 20) return 'ม.ต้น'
    if (gradeLevel === 30) return 'ม.ปลาย'
    if (gradeLevel === 7) return 'ม.1'
    if (gradeLevel === 8) return 'ม.2'
    if (gradeLevel === 9) return 'ม.3'
    if (gradeLevel === 10) return 'ม.4'
    if (gradeLevel === 11) return 'ม.5'
    if (gradeLevel === 12) return 'ม.6'
    const displayGrade = gradeLevel >= 7 ? gradeLevel - 6 : gradeLevel
    return `ม.${displayGrade}`
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(255, 255, 255, 0.1)',
          borderTopColor: 'var(--primary)',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
      {/* Header */}
      <div className="admin-academic-header">
        <div className="admin-academic-title-section">
          <h1 className="admin-academic-title">🏫 จัดการข้อมูลวิชาการของโรงเรียน</h1>
          <p style={{ color: 'var(--text-secondary)' }}>ทะเบียนประวัตินักเรียน ตารางรายวิชาเรียน และโครงสร้างระดับชั้นการสอนของโรงเรียน</p>
        </div>
        <div className="admin-academic-actions">
          {/* Year/Semester Select Dropdown */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'var(--bg-card)', padding: '6px 16px', borderRadius: '20px', border: '1px solid var(--border)' }}>
            <span style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>ปีการศึกษา/เทอม:</span>
            <select
              value={selectedYearId}
              onChange={(e) => setSelectedYearId(Number(e.target.value))}
              style={{ background: 'transparent', border: 'none', fontSize: '13px', fontWeight: '700', color: 'var(--text-primary)', cursor: 'pointer', outline: 'none' }}
            >
              {academicYears.map(y => (
                <option key={y.id} value={y.id} style={{ background: '#ffffff', color: '#000000' }}>ภาคเรียนที่ {y.semester}/{y.year}</option>
              ))}
            </select>
          </div>
          <button onClick={() => setShowRoomTypeModal(true)} className="btn btn-outline" style={{ fontSize: '13px', borderRadius: '20px' }}>
            ➕ ประเภทห้องเรียน
          </button>
          <button onClick={() => setShowDepartmentModal(true)} className="btn btn-outline" style={{ fontSize: '13px', borderRadius: '20px' }}>
            🏫 จัดการกลุ่มสาระฯ
          </button>
          {activeTab === 'students' && (
            <>
              <button onClick={() => triggerSecureAction('🚀 กรุณากรอกรหัสผ่านเพื่อเข้าสู่โหมดจัดการข้อมูลแบบรายห้องเรียน', () => setShowBulkClassroomModal(true))} className="btn btn-outline" style={{ fontSize: '13px', borderRadius: '20px', borderColor: 'var(--primary)', color: 'var(--primary)' }}>
                🚀 จัดการแบบรายห้องเรียน
              </button>
              <button onClick={() => triggerSecureAction('🎓 กรุณากรอกรหัสผ่านเพื่อเข้าสู่โหมดเพิ่มนักเรียนใหม่', () => {
                setShowAddStudentModal(true)
                setStGrade(7)
                setStRoom('1')
              })} className="btn btn-primary" style={{ fontSize: '13px', borderRadius: '20px' }}>
                🎓 เพิ่มนักเรียนใหม่ (รายบุคคล)
              </button>
            </>
          )}
          {activeTab === 'subjects' && (
            <button onClick={() => triggerSecureAction('📚 กรุณากรอกรหัสผ่านเพื่อเข้าสู่โหมดเพิ่มวิชาเรียนใหม่', () => setShowAddSubjectModal(true))} className="btn btn-primary" style={{ fontSize: '13px', borderRadius: '20px' }}>
              📚 เพิ่มวิชาเรียนใหม่ (รายบุคคล)
            </button>
          )}
          {activeTab === 'assignments' && (
            <button onClick={() => setShowAddAssignmentModal(true)} className="btn btn-primary" style={{ fontSize: '13px', borderRadius: '20px' }}>
              ✏️ มอบหมายงานสอนใหม่
            </button>
          )}
        </div>
      </div>

      {notification && (
        <div style={{
          background: notification.type === 'success' ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
          border: `1px solid ${notification.type === 'success' ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)'}`,
          borderRadius: '8px',
          padding: '16px',
          color: notification.type === 'success' ? 'var(--success)' : 'var(--danger)',
          fontSize: '14px'
        }}>
          {notification.message}
        </div>
      )}

      {/* Tabs */}
      <div className="admin-academic-tabs">
        <button
          type="button"
          onClick={() => setActiveTab('students')}
          className={`btn ${activeTab === 'students' ? 'btn-primary' : 'btn-outline'} admin-academic-tab-btn`}
          style={{ padding: '8px 20px', fontSize: '13px', borderRadius: '20px' }}
        >
          🎓 รายชื่อนักเรียนทั้งหมด ({students.length})
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('subjects')}
          className={`btn ${activeTab === 'subjects' ? 'btn-primary' : 'btn-outline'} admin-academic-tab-btn`}
          style={{ padding: '8px 20px', fontSize: '13px', borderRadius: '20px' }}
        >
          📚 รายวิชาเรียนทั้งหมด ({subjects.length})
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('imports')}
          className={`btn ${activeTab === 'imports' ? 'btn-primary' : 'btn-outline'} admin-academic-tab-btn`}
          style={{ padding: '8px 20px', fontSize: '13px', borderRadius: '20px' }}
        >
          📂 ศูนย์นำเข้า Excel กลุ่มใหญ่
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('assignments')}
          className={`btn ${activeTab === 'assignments' ? 'btn-primary' : 'btn-outline'} admin-academic-tab-btn`}
          style={{ padding: '8px 20px', fontSize: '13px', borderRadius: '20px' }}
        >
          ✏️ มอบหมายงานสอน ({teachingAssignments.length})
        </button>
        <button
          type="button"
          onClick={() => setActiveTab('cleanup')}
          className={`btn ${activeTab === 'cleanup' ? 'btn-primary' : 'btn-outline'} admin-academic-tab-btn`}
          style={{ padding: '8px 20px', fontSize: '13px', borderRadius: '20px' }}
        >
          ⚙️ เคลียร์/ลบข้อมูลระบบ
        </button>
      </div>


      {/* TAB 1: STUDENTS LIST */}
      {activeTab === 'students' && (
        <div className="glassmorphism" style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          {/* SEARCH FILTERS SECTION */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px', borderBottom: '1px solid var(--border)', paddingBottom: '16px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>รหัสนักเรียน</label>
              <input 
                type="text" 
                className="input-field" 
                placeholder="ค้นหารหัสนักเรียน..." 
                value={searchStudentId} 
                onChange={(e) => setSearchStudentId(e.target.value)} 
                style={{ fontSize: '13px', padding: '8px 12px' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>ชื่อ - นามสกุล</label>
              <input 
                type="text" 
                className="input-field" 
                placeholder="ค้นหาชื่อ-นามสกุล..." 
                value={searchStudentName} 
                onChange={(e) => setSearchStudentName(e.target.value)}
                style={{ fontSize: '13px', padding: '8px 12px' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>ระดับชั้นเรียน</label>
              <select 
                className="input-field" 
                value={searchStudentGrade} 
                onChange={(e) => setSearchStudentGrade(e.target.value)}
                style={{ fontSize: '13px', padding: '8px 12px', background: 'var(--bg-card)' }}
              >
                <option value="all">ทั้งหมด</option>
                <option value="7">ม.1</option>
                <option value="8">ม.2</option>
                <option value="9">ม.3</option>
                <option value="10">ม.4</option>
                <option value="11">ม.5</option>
                <option value="12">ม.6</option>
                <option value="20">ม.ต้น (ทั่วไป)</option>
                <option value="30">ม.ปลาย (ทั่วไป)</option>
              </select>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>ห้องเรียน</label>
              <select 
                className="input-field" 
                value={searchStudentRoom} 
                onChange={(e) => {
                  setSearchStudentRoom(e.target.value)
                  // reset grade filter when a specific classroom is chosen
                  if (e.target.value !== 'all') setSearchStudentGrade('all')
                }}
                style={{ fontSize: '13px', padding: '8px 12px' }}
              >
                <option value="all">ทั้งหมด</option>
                {[...classrooms]
                  .sort((a: any, b: any) => {
                    if (a.grade_level !== b.grade_level) return a.grade_level - b.grade_level
                    return parseInt(a.room_number, 10) - parseInt(b.room_number, 10)
                  })
                  .map((c: any) => {
                    const grade = c.grade_level >= 7 && c.grade_level <= 12
                      ? `ม.${c.grade_level - 6}`
                      : c.grade_level >= 20 ? (c.grade_level === 20 ? 'ม.ต้น' : 'ม.ปลาย') : `ชั้น ${c.grade_level}`
                    return (
                      <option key={c.id} value={String(c.id)}>{grade}/{c.room_number}</option>
                    )
                  })
                }
              </select>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>เรียงลำดับตาม</label>
              <select 
                className="input-field" 
                value={studentSortBy} 
                onChange={(e) => setStudentSortBy(e.target.value)}
                style={{ fontSize: '13px', padding: '8px 12px' }}
              >
                <option value="classroom">ห้องเรียนและเลขที่</option>
                <option value="student_id_card">รหัสประจำตัว</option>
                <option value="name">ชื่อ-นามสกุล</option>
                <option value="number_in_class">เลขที่นักเรียน</option>
              </select>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>ลำดับการเรียง</label>
              <select 
                className="input-field" 
                value={studentSortOrder} 
                onChange={(e) => setStudentSortOrder(e.target.value as 'asc' | 'desc')}
                style={{ fontSize: '13px', padding: '8px 12px' }}
              >
                <option value="asc">น้อยไปหามาก (ASC)</option>
                <option value="desc">มากไปหาน้อย (DESC)</option>
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button 
                type="button" 
                onClick={() => {
                  setSearchStudentId('')
                  setSearchStudentName('')
                  setSearchStudentGrade('all')
                  setSearchStudentRoom('all')
                  setStudentSortBy('classroom')
                  setStudentSortOrder('asc')
                }}
                className="btn btn-outline" 
                style={{ width: '100%', padding: '8px 16px', fontSize: '13px' }}
              >
                🧹 ล้างการค้นหา
              </button>
            </div>
          </div>

          {/* TABLE ACTIONS TOOLBAR */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginTop: '8px' }}>
            <span style={{ fontSize: '13px', color: 'var(--text-secondary)', fontWeight: '500' }}>
              📊 ค้นพบนักเรียน {sortedStudents.length} คน จากทั้งหมด {students.length} คน
            </span>
            <button 
              type="button" 
              onClick={() => {
                setSelectedColumns({
                  studentCode: true,
                  prefix: true,
                  name: true,
                  grade: true,
                  room: true,
                  no: true,
                  roomType: true,
                  status: true,
                  scorePre: true,
                  scorePost: true,
                  gain: true,
                  evaluation: true
                });
                setExportSelectedSubject('');
                setShowExportModal(true);
              }}
              className="btn btn-outline" 
              style={{ display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid var(--primary)', color: 'var(--primary)', fontWeight: '600', padding: '8px 16px', fontSize: '13px' }}
            >
              📊 ส่งออกรายงาน Excel (กำหนดหัวข้อเอง)
            </button>
          </div>

          {/* TABLE CONTAINER */}
          <div className="custom-table-container">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>เลขประจำตัว</th>
                  <th>คำนำหน้า</th>
                  <th>ชื่อ-นามสกุล</th>
                  <th>ห้องเรียน</th>
                  <th style={{ textAlign: 'center' }}>เลขที่</th>
                  <th>ประเภทห้อง</th>
                  <th style={{ textAlign: 'center' }}>สถานะ</th>
                  <th style={{ textAlign: 'center' }}>การจัดการ</th>
                </tr>
              </thead>
              <tbody>
                {paginatedStudents.length === 0 ? (
                  <tr>
                    <td colSpan={8} style={{ textAlign: 'center', padding: '32px', color: 'var(--text-muted)' }}>
                      📭 ไม่พบข้อมูลนักเรียนตามเงื่อนไขที่ค้นหา
                    </td>
                  </tr>
                ) : (
                  paginatedStudents.map((st) => (
                    <tr key={st.id} style={{ opacity: st.status && st.status !== 'active' ? 0.5 : 1 }}>
                      <td><code>{st.student_id_card}</code></td>
                      <td>{st.title || 'เด็กชาย'}</td>
                      <td><strong>{st.first_name} {st.last_name}</strong></td>
                      <td>{getClassroomStr(st.classroom_id)}</td>
                      <td style={{ textAlign: 'center' }}>{st.number_in_class || '—'}</td>
                      <td><span className="badge" style={{ background: 'rgba(0,184,148,0.1)', color: 'var(--primary)' }}>{st.room_type || 'Normal'}</span></td>
                      <td style={{ textAlign: 'center' }}>
                        <span style={{
                          color: st.status === 'active' || !st.status ? 'var(--success)' : st.status === 'resigned' ? 'var(--danger)' : 'var(--warning)',
                          fontWeight: '700',
                          fontSize: '12px'
                        }}>
                          {st.status === 'active' || !st.status ? '🟢 ปกติ' : st.status === 'resigned' ? '🔴 ลาออก' : '🟡 ย้ายห้อง'}
                        </span>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <div style={{ display: 'inline-flex', gap: '8px' }}>
                          <button onClick={() => triggerSecureAction('✏️ กรุณากรอกรหัสผ่านเพื่อเข้าสู่โหมดแก้ไขข้อมูลนักเรียน', () => {
                            setShowEditStudentModal(st)
                            const cl = classrooms.find(c => c.id === st.classroom_id)
                            setEditStGrade(cl ? cl.grade_level : 7)
                            setEditStRoom(cl ? cl.room_number : '1')
                          })} className="btn btn-outline" style={{ padding: '4px 8px', fontSize: '11px' }}>✏️ แก้ไข</button>
                          <button onClick={() => handleDeleteStudent(st.id)} className="btn btn-outline" style={{ padding: '4px 8px', fontSize: '11px', color: 'var(--danger)', borderColor: 'rgba(239,68,68,0.15)' }}>🗑️ ลบ</button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION CONTROLS */}
          {totalStudentPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid var(--border)', paddingTop: '16px' }}>
              <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                แสดงผลแถวที่ {Math.min(sortedStudents.length, (studentPage - 1) * itemsPerPage + 1)} - {Math.min(sortedStudents.length, studentPage * itemsPerPage)} จากทั้งหมด {sortedStudents.length} คน
              </span>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button 
                  disabled={studentPage === 1} 
                  onClick={() => setStudentPage(p => Math.max(1, p - 1))}
                  className="btn btn-outline" 
                  style={{ padding: '6px 12px', fontSize: '12px' }}
                >
                  ◀ ก่อนหน้า
                </button>
                <span style={{ display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: '600', padding: '0 8px' }}>
                  หน้า {studentPage} / {totalStudentPages}
                </span>
                <button 
                  disabled={studentPage === totalStudentPages} 
                  onClick={() => setStudentPage(p => Math.min(totalStudentPages, p + 1))}
                  className="btn btn-outline" 
                  style={{ padding: '6px 12px', fontSize: '12px' }}
                >
                  ถัดไป ▶
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* TAB 2: SUBJECTS LIST */}
      {activeTab === 'subjects' && (
        <div className="glassmorphism" style={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          {/* SEARCH FILTERS SECTION */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', borderBottom: '1px solid var(--border)', paddingBottom: '16px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>รหัสวิชา</label>
              <input 
                type="text" 
                className="input-field" 
                placeholder="ค้นหารหัสวิชา..." 
                value={searchSubjectCode} 
                onChange={(e) => setSearchSubjectCode(e.target.value)} 
                style={{ fontSize: '13px', padding: '8px 12px' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>ชื่อวิชา</label>
              <input 
                type="text" 
                className="input-field" 
                placeholder="ค้นหาชื่อวิชา..." 
                value={searchSubjectName} 
                onChange={(e) => setSearchSubjectName(e.target.value)}
                style={{ fontSize: '13px', padding: '8px 12px' }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>เรียงลำดับตาม</label>
              <select 
                className="input-field" 
                value={subjectSortBy} 
                onChange={(e) => setSubjectSortBy(e.target.value)}
                style={{ fontSize: '13px', padding: '8px 12px' }}
              >
                <option value="grade_level">ระดับชั้นเรียน</option>
                <option value="code">รหัสวิชา</option>
                <option value="name">ชื่อวิชา</option>
                <option value="credits">หน่วยกิต</option>
              </select>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>ลำดับการเรียง</label>
              <select 
                className="input-field" 
                value={subjectSortOrder} 
                onChange={(e) => setSubjectSortOrder(e.target.value as 'asc' | 'desc')}
                style={{ fontSize: '13px', padding: '8px 12px' }}
              >
                <option value="asc">น้อยไปหามาก (ASC)</option>
                <option value="desc">มากไปหาน้อย (DESC)</option>
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button 
                type="button" 
                onClick={() => {
                  setSearchSubjectCode('')
                  setSearchSubjectName('')
                  setSubjectSortBy('grade_level')
                  setSubjectSortOrder('asc')
                }}
                className="btn btn-outline" 
                style={{ width: '100%', padding: '8px 16px', fontSize: '13px' }}
              >
                🧹 ล้างการค้นหา
              </button>
            </div>
          </div>

          {/* TABLE CONTAINER */}
          <div className="custom-table-container">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>รหัสวิชา</th>
                  <th>ชื่อวิชา</th>
                  <th style={{ textAlign: 'center' }}>หน่วยกิต</th>
                </tr>
              </thead>
              <tbody>
                {paginatedSubjects.length === 0 ? (
                  <tr>
                    <td colSpan={7} style={{ textAlign: 'center', padding: '32px', color: 'var(--text-muted)' }}>
                      📭 ไม่พบข้อมูลรายวิชาเรียนตามเงื่อนไขที่ค้นหา
                    </td>
                  </tr>
                ) : (
                  paginatedSubjects.map((sub) => (
                    <tr key={sub.id}>
                      <td><code>{sub.code}</code></td>
                      <td><strong>{sub.name}</strong></td>
                      <td style={{ textAlign: 'center' }}>{sub.credits || '1.5'}</td>
                      <td style={{ textAlign: 'center' }}>{getSubjectGradeStr(sub.grade_level)}</td>
                      <td style={{ textAlign: 'center' }}>{sub.max_score_pre} คะแนน</td>
                      <td style={{ textAlign: 'center' }}>{sub.max_score_post} คะแนน</td>
                      <td style={{ textAlign: 'center' }}>
                        <div style={{ display: 'inline-flex', gap: '8px' }}>
                          <button onClick={() => triggerSecureAction('✏️ กรุณากรอกรหัสผ่านเพื่อเข้าสู่โหมดแก้ไขข้อมูลรายวิชา', () => setShowEditSubjectModal(sub))} className="btn btn-outline" style={{ padding: '4px 8px', fontSize: '11px' }}>✏️ แก้ไข</button>
                          <button onClick={() => handleDeleteSubject(sub.id)} className="btn btn-outline" style={{ padding: '4px 8px', fontSize: '11px', color: 'var(--danger)', borderColor: 'rgba(239,68,68,0.15)' }}>🗑️ ลบ</button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION CONTROLS */}
          {totalSubjectPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid var(--border)', paddingTop: '16px' }}>
              <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
                แสดงผลแถวที่ {Math.min(sortedSubjects.length, (subjectPage - 1) * itemsPerPage + 1)} - {Math.min(sortedSubjects.length, subjectPage * itemsPerPage)} จากทั้งหมด {sortedSubjects.length} วิชา
              </span>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button 
                  disabled={subjectPage === 1} 
                  onClick={() => setSubjectPage(p => Math.max(1, p - 1))}
                  className="btn btn-outline" 
                  style={{ padding: '6px 12px', fontSize: '12px' }}
                >
                  ◀ ก่อนหน้า
                </button>
                <span style={{ display: 'flex', alignItems: 'center', fontSize: '13px', fontWeight: '600', padding: '0 8px' }}>
                  หน้า {subjectPage} / {totalSubjectPages}
                </span>
                <button 
                  disabled={subjectPage === totalSubjectPages} 
                  onClick={() => setSubjectPage(p => Math.min(totalSubjectPages, p + 1))}
                  className="btn btn-outline" 
                  style={{ padding: '6px 12px', fontSize: '12px' }}
                >
                  ถัดไป ▶
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* TAB 3: IMPORTS */}
      {activeTab === 'imports' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '28px' }}>
          
          {/* Excel Import Students */}
          <div className="glassmorphism" style={{ padding: '28px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>🎓 นำเข้ารายชื่อนักเรียนแบบกลุ่มใหญ่ (Excel)</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: '12px', marginBottom: '20px', lineHeight: '1.5' }}>
                อัปโหลดไฟล์ Excel ที่มีหัวคอลัมน์: <code style={{ color: 'var(--primary)' }}>รหัสนักเรียน</code>, <code style={{ color: 'var(--primary)' }}>คำนำหน้า</code>, <code style={{ color: 'var(--primary)' }}>ชื่อ</code>, <code style={{ color: 'var(--primary)' }}>นามสกุล</code>, <code style={{ color: 'var(--primary)' }}>ระดับชั้นและห้อง</code>, <code style={{ color: 'var(--primary)' }}>เลขที่</code>, <code style={{ color: 'var(--primary)' }}>ประเภทห้อง</code>
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <button onClick={downloadStudentExcelSample} className="btn btn-outline" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                📥 ดาวน์โหลดไฟล์ตัวอย่างนักเรียน (.xlsx)
              </button>
              <label className="btn btn-primary" style={{ display: 'flex', cursor: 'pointer', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                📁 เลือกไฟล์ Excel รายชื่อนักเรียน
                <input type="file" accept=".xlsx, .xls" onChange={handleExcelImportStudents} style={{ display: 'none' }} />
              </label>
            </div>
          </div>

          {/* Excel Import Subjects */}
          <div className="glassmorphism" style={{ padding: '28px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div>
              <h2 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>📚 นำเข้าโครงสร้างรายวิชาเรียน (Excel)</h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: '12px', marginBottom: '20px', lineHeight: '1.5' }}>
                อัปโหลดไฟล์ Excel ที่มีหัวคอลัมน์: <code style={{ color: 'var(--primary)' }}>รหัสวิชา</code>, <code style={{ color: 'var(--primary)' }}>ชื่อวิชา</code>, <code style={{ color: 'var(--primary)' }}>หน่วยกิต</code>, <code style={{ color: 'var(--primary)' }}>ระดับชั้น</code>
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <button onClick={downloadSubjectExcelSample} className="btn btn-outline" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                📥 ดาวน์โหลดไฟล์ตัวอย่างวิชาเรียน (.xlsx)
              </button>
              <label className="btn btn-primary" style={{ display: 'flex', cursor: 'pointer', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                📁 เลือกไฟล์ Excel ตารางรายวิชา
                <input type="file" accept=".xlsx, .xls" onChange={handleExcelImportSubjects} style={{ display: 'none' }} />
              </label>
            </div>
          </div>

        </div>
      )}

      {/* TAB 4: TEACHING ASSIGNMENTS */}
      {activeTab === 'assignments' && (() => {
        // Helper: display classroom correctly (grade_level - 6 for ม.1-6)
        const getClassStr = (c: any) => {
          if (!c) return 'ไม่ทราบห้อง'
          const g = c.grade_level >= 7 && c.grade_level <= 12 ? c.grade_level - 6
            : c.grade_level === 20 ? 'ต้น' : c.grade_level === 30 ? 'ปลาย' : c.grade_level
          return `ม.${g}/${c.room_number}`
        }

        // Group assignments by teacher
        const grouped: Record<string, { teacher: any; items: any[] }> = {}
        teachingAssignments.forEach((assign: any) => {
          const teacher = teachers.find(t => t.id === assign.teacher_id)
          const tid = assign.teacher_id || 'unassigned'
          if (!grouped[tid]) grouped[tid] = { teacher, items: [] }
          grouped[tid].items.push(assign)
        })
        const groups = Object.entries(grouped)

        const toggleCollapse = (tid: string) => {
          setCollapsedTeachers(prev => {
            const next = new Set(prev)
            next.has(tid) ? next.delete(tid) : next.add(tid)
            return next
          })
        }

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {teachingAssignments.length === 0 ? (
              <div className="glassmorphism" style={{ padding: '40px', textAlign: 'center', color: 'var(--text-secondary)' }}>
                📭 ยังไม่มีการมอบหมายงานสอนในขณะนี้
              </div>
            ) : groups.map(([tid, group]) => {
              const isCollapsed = collapsedTeachers.has(tid)
              const teacher = group.teacher
              const teacherName = teacher ? `${teacher.first_name} ${teacher.last_name}` : 'ไม่ระบุครู'
              const roleLabel = teacher?.role === 'head_of_department' ? 'หัวหน้าสาระ' : 'ครูผู้สอน'
              const roleColor = teacher?.role === 'head_of_department' ? 'var(--primary)' : 'var(--secondary)'

              return (
                <div key={tid} className="glassmorphism" style={{ overflow: 'hidden', border: '1px solid var(--border)', borderRadius: '12px' }}>
                  {/* Teacher group header */}
                  <div
                    onClick={() => toggleCollapse(tid)}
                    style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '14px 20px', cursor: 'pointer',
                      background: isCollapsed ? 'var(--bg-card)' : 'rgba(0,184,148,0.04)',
                      borderBottom: isCollapsed ? 'none' : '1px solid var(--border)',
                      userSelect: 'none'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <span style={{ fontSize: '16px', color: 'var(--text-secondary)' }}>{isCollapsed ? '▶' : '▼'}</span>
                      <div>
                        <span style={{ fontWeight: '700', fontSize: '15px' }}>👨‍🏫 {teacherName}</span>
                        <span style={{
                          marginLeft: '10px', fontSize: '11px', fontWeight: '600',
                          background: teacher?.role === 'head_of_department' ? 'rgba(0,184,148,0.15)' : 'rgba(9,132,227,0.15)',
                          color: roleColor, border: `1px solid ${roleColor}`,
                          padding: '2px 8px', borderRadius: '10px'
                        }}>{roleLabel}</span>
                      </div>
                    </div>
                    <span style={{ fontSize: '12px', color: 'var(--text-secondary)', fontWeight: '600' }}>
                      {group.items.length} รายวิชา/ห้อง {isCollapsed ? '(คลิกเพื่อขยาย)' : '(คลิกเพื่อย่อ)'}
                    </span>
                  </div>

                  {/* Expanded content */}
                  {!isCollapsed && (
                    <div className="custom-table-container">
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th>วิชาเรียน</th>
                            <th>ห้องเรียน</th>
                            <th style={{ textAlign: 'center' }}>การจัดการ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {group.items.map((assign: any) => {
                            const sub = subjects.find(s => s.id === assign.subject_id)
                            const classroom = classrooms.find(c => c.id === assign.classroom_id)
                            return (
                              <tr key={assign.id}>
                                <td><strong>{sub ? `[${sub.code}] ${sub.name}` : 'ไม่ทราบวิชา'}</strong></td>
                                <td><span style={{ fontWeight: '700', color: 'var(--primary)' }}>{getClassStr(classroom)}</span></td>
                                <td style={{ textAlign: 'center' }}>
                                  <div style={{ display: 'inline-flex', gap: '8px' }}>
                                    <button
                                      onClick={() => {
                                        setEditAssignId(assign.id)
                                        setEditAssignTeacherId(assign.teacher_id || '')
                                        setEditAssignSubjectId(String(assign.subject_id))
                                        setEditAssignClassroomId(String(assign.classroom_id))
                                        setShowEditAssignmentModal(true)
                                      }}
                                      className="btn btn-outline"
                                      style={{ padding: '4px 10px', fontSize: '12px' }}
                                    >✏️ แก้ไข</button>
                                    <button
                                      onClick={() => handleDeleteAssignment(assign.id)}
                                      className="btn btn-outline"
                                      style={{ padding: '4px 10px', fontSize: '12px', color: 'var(--danger)', borderColor: 'rgba(239,68,68,0.2)' }}
                                    >🗑️ ยกเลิก</button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )
      })()}


      {/* TAB 5: SYSTEM CLEANUP */}
      {activeTab === 'cleanup' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <div className="glassmorphism" style={{ padding: '28px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <h2 style={{ fontSize: '18px', fontWeight: '700', color: 'var(--accent)', margin: 0 }}>⚠️ จัดการทำความสะอาดและล้างข้อมูลระบบ (Danger Zone)</h2>
            <p style={{ color: 'var(--text-secondary)', fontSize: '13px', lineHeight: '1.6' }}>
              ในส่วนนี้ แอดมินสามารถเลือกล้างข้อมูลต่าง ๆ ในระบบเพื่อเตรียมการขึ้นปีการศึกษาใหม่ หรือรีเซ็ตโครงสร้างวิชาเรียน 
              การกระทำนี้จะลบข้อมูลออกจากฐานข้อมูลถาวรและไม่สามารถกู้คืนได้ กรุณาตรวจสอบให้มั่นใจก่อนดำเนินการ
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginTop: '12px' }}>
              
              {/* Card 1: Clear All */}
              <div style={{ border: '1px solid var(--border)', borderRadius: '12px', padding: '20px', background: 'rgba(239, 68, 68, 0.02)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '16px' }}>
                <div>
                  <h3 style={{ fontSize: '15px', fontWeight: '700', color: 'var(--accent)', marginBottom: '8px' }}>💥 ลบข้อมูลระบบทั้งหมด</h3>
                  <p style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.5' }}>
                    ลบข้อมูลผลคะแนนดิบ (Pre/Post Test), รายชื่อนักเรียนทั้งหมด, รายวิชาทั้งหมด, งานมอบหมายครู และตารางห้องเรียน (ยกเว้นสิทธิ์บัญชีผู้ใช้งาน)
                  </p>
                </div>
                <button 
                  type="button" 
                  onClick={handleClearAllData}
                  className="btn" 
                  style={{ width: '100%', background: 'var(--accent)', color: '#fff', fontSize: '13px', fontWeight: '700' }}
                >
                  🔥 ล้างข้อมูลทั้งหมดในระบบ
                </button>
              </div>

              {/* Card 2: Clear Subjects */}
              <div style={{ border: '1px solid var(--border)', borderRadius: '12px', padding: '20px', background: 'rgba(245, 158, 11, 0.02)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '16px' }}>
                <div>
                  <h3 style={{ fontSize: '15px', fontWeight: '700', color: 'var(--warning)', marginBottom: '8px' }}>📚 ลบรายวิชาทั้งหมด</h3>
                  <p style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.5' }}>
                    ลบข้อมูลรายวิชาเรียนทั้งหมดในระบบ ซึ่งจะลบผลคะแนนสอบและตารางมอบหมายการสอนที่เชื่อมโยงกับวิชาเหล่านั้นด้วย
                  </p>
                </div>
                <button 
                  type="button" 
                  onClick={handleClearAllSubjects}
                  className="btn btn-secondary" 
                  style={{ width: '100%', background: 'var(--warning)', borderColor: 'var(--warning)', color: '#fff', fontSize: '13px', fontWeight: '700' }}
                >
                  🗑️ ล้างรายวิชาเรียนทั้งหมด
                </button>
              </div>

              {/* Card 3: Clear Classroom */}
              <div style={{ border: '1px solid var(--border)', borderRadius: '12px', padding: '20px', background: 'var(--bg-card)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '16px' }}>
                <div>
                  <h3 style={{ fontSize: '15px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>🏫 ลบข้อมูลตามรายห้องเรียน</h3>
                  <p style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.5', marginBottom: '12px' }}>
                    เลือกลบห้องเรียนที่ระบุ ซึ่งจะทำการลบรายชื่อนักเรียนและผลคะแนนสอบทั้งหมดของห้องเรียนนั้น ๆ ออกจากระบบ
                  </p>
                  
                  <label className="input-label" style={{ fontSize: '11px' }}>เลือกห้องเรียนที่ต้องการลบ</label>
                  <select 
                    className="input-field" 
                    value={cleanupClassroomId} 
                    onChange={(e) => setCleanupClassroomId(e.target.value)}
                    style={{ fontSize: '13px', padding: '6px 10px', background: 'var(--bg-card)' }}
                  >
                    <option value="">-- เลือกห้องเรียน --</option>
                    {classrooms.map((c: any) => {
                      const name = `ม.${c.grade_level >= 7 ? c.grade_level - 6 : c.grade_level}/${c.room_number}`
                      return <option key={c.id} value={c.id}>{name}</option>
                    })}
                  </select>
                </div>
                <button 
                  type="button" 
                  onClick={handleClearClassroomData}
                  disabled={!cleanupClassroomId}
                  className="btn btn-outline" 
                  style={{ width: '100%', fontSize: '13px', fontWeight: '700', color: cleanupClassroomId ? 'var(--accent)' : 'var(--text-muted)', borderColor: cleanupClassroomId ? 'var(--accent)' : 'var(--border)' }}
                >
                  ❌ ลบข้อมูลห้องเรียนที่เลือก
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* MODAL 1: Add Student Modal */}
      {showAddStudentModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '520px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>🎓 เพิ่มประวัตินักเรียนใหม่รายบุคคล</h3>
            <form onSubmit={handleAddStudent} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label" htmlFor="studentIdCardModal">รหัสประจำตัวนักเรียน</label>
                <input id="studentIdCardModal" type="text" className="input-field" value={stIdCard} onChange={(e) => setStIdCard(e.target.value)} required />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px' }}>
                <div>
                  <label className="input-label" htmlFor="studentTitleModal">คำนำหน้า</label>
                  <select id="studentTitleModal" className="input-field" value={stTitle} onChange={(e) => setStTitle(e.target.value)} style={{ background: 'var(--bg-input)' }}>
                    <option value="เด็กชาย">เด็กชาย</option>
                    <option value="เด็กหญิง">เด็กหญิง</option>
                    <option value="นาย">นาย</option>
                    <option value="นางสาว">นางสาว</option>
                  </select>
                </div>
                <div>
                  <label className="input-label" htmlFor="studentFirstNameModal">ชื่อจริง</label>
                  <input id="studentFirstNameModal" type="text" className="input-field" value={stFirstName} onChange={(e) => setStFirstName(e.target.value)} required />
                </div>
              </div>
              <div>
                <label className="input-label" htmlFor="studentLastNameModal">นามสกุล</label>
                <input id="studentLastNameModal" type="text" className="input-field" value={stLastName} onChange={(e) => setStLastName(e.target.value)} required />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="input-label" htmlFor="studentGradeModal">ระดับชั้นเรียน</label>
                  <select id="studentGradeModal" className="input-field" value={stGrade} onChange={(e) => setStGrade(Number(e.target.value))} style={{ background: 'var(--bg-input)' }} required>
                    <option value="7">ม.1</option>
                    <option value="8">ม.2</option>
                    <option value="9">ม.3</option>
                    <option value="10">ม.4</option>
                    <option value="11">ม.5</option>
                    <option value="12">ม.6</option>
                  </select>
                </div>
                <div>
                  <label className="input-label" htmlFor="studentRoomModal">ห้องเรียน</label>
                  <select id="studentRoomModal" className="input-field" value={stRoom} onChange={(e) => setStRoom(e.target.value)} style={{ background: 'var(--bg-input)' }} required>
                    {Array.from({ length: 26 }, (_, i) => String(i + 1)).map(room => (
                      <option key={room} value={room}>ห้อง {room}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="input-label" htmlFor="studentRoomTypeModal">ประเภทห้องเรียน</label>
                  <select id="studentRoomTypeModal" className="input-field" value={stRoomType} onChange={(e) => setStRoomType(e.target.value)} style={{ background: 'var(--bg-input)' }}>
                    {roomTypes.map(t => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <label className="input-label" htmlFor="studentNumberModal">เลขที่ในห้องเรียน</label>
                <input id="studentNumberModal" type="number" className="input-field" value={stNumber} onChange={(e) => setStNumber(Number(e.target.value))} required />
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button type="button" onClick={() => setShowAddStudentModal(false)} className="btn btn-outline">ยกเลิก</button>
                <button type="submit" className="btn btn-primary">✓ บันทึกข้อมูลนักเรียน</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL 2: Edit Student Modal (Transfer, status, details) */}
      {showEditStudentModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '520px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>✏️ แก้ไขข้อมูล/ย้ายห้องเรียนนักเรียน</h3>
            <form onSubmit={handleUpdateStudent} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label" htmlFor="editStIdCard">รหัสประจำตัวนักเรียน</label>
                <input id="editStIdCard" type="text" className="input-field" value={showEditStudentModal.student_id_card} onChange={(e) => setShowEditStudentModal({ ...showEditStudentModal, student_id_card: e.target.value })} required />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px' }}>
                <div>
                  <label className="input-label" htmlFor="editStTitle">คำนำหน้า</label>
                  <select id="editStTitle" className="input-field" value={showEditStudentModal.title} onChange={(e) => setShowEditStudentModal({ ...showEditStudentModal, title: e.target.value })} style={{ background: 'var(--bg-input)' }}>
                    <option value="เด็กชาย">เด็กชาย</option>
                    <option value="เด็กหญิง">เด็กหญิง</option>
                    <option value="นาย">นาย</option>
                    <option value="นางสาว">นางสาว</option>
                  </select>
                </div>
                <div>
                  <label className="input-label" htmlFor="editStFirstName">ชื่อจริง</label>
                  <input id="editStFirstName" type="text" className="input-field" value={showEditStudentModal.first_name} onChange={(e) => setShowEditStudentModal({ ...showEditStudentModal, first_name: e.target.value })} required />
                </div>
              </div>
              <div>
                <label className="input-label" htmlFor="editStLastName">นามสกุล</label>
                <input id="editStLastName" type="text" className="input-field" value={showEditStudentModal.last_name} onChange={(e) => setShowEditStudentModal({ ...showEditStudentModal, last_name: e.target.value })} required />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="input-label" htmlFor="editStGrade">ระดับชั้นเรียน</label>
                  <select id="editStGrade" className="input-field" value={editStGrade} onChange={(e) => setEditStGrade(Number(e.target.value))} style={{ background: 'var(--bg-input)' }} required>
                    <option value="7">ม.1</option>
                    <option value="8">ม.2</option>
                    <option value="9">ม.3</option>
                    <option value="10">ม.4</option>
                    <option value="11">ม.5</option>
                    <option value="12">ม.6</option>
                  </select>
                </div>
                <div>
                  <label className="input-label" htmlFor="editStRoom">ห้องเรียน</label>
                  <select id="editStRoom" className="input-field" value={editStRoom} onChange={(e) => setEditStRoom(e.target.value)} style={{ background: 'var(--bg-input)' }} required>
                    {Array.from({ length: 26 }, (_, i) => String(i + 1)).map(room => (
                      <option key={room} value={room}>ห้อง {room}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="input-label" htmlFor="editStRoomType">ประเภทห้องเรียน</label>
                  <select id="editStRoomType" className="input-field" value={showEditStudentModal.room_type} onChange={(e) => setShowEditStudentModal({ ...showEditStudentModal, room_type: e.target.value })} style={{ background: 'var(--bg-input)' }}>
                    {roomTypes.map(t => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="input-label" htmlFor="editStNumber">เลขที่</label>
                  <input id="editStNumber" type="number" className="input-field" value={showEditStudentModal.number_in_class || 1} onChange={(e) => setShowEditStudentModal({ ...showEditStudentModal, number_in_class: Number(e.target.value) })} required />
                </div>
                <div>
                  <label className="input-label" htmlFor="editStStatus">สถานะการเรียน</label>
                  <select id="editStStatus" className="input-field" value={showEditStudentModal.status || 'active'} onChange={(e) => setShowEditStudentModal({ ...showEditStudentModal, status: e.target.value })} style={{ background: 'var(--bg-input)' }}>
                    <option value="active">ปกติ (Active)</option>
                    <option value="resigned">ลาออก (Resigned)</option>
                    <option value="transferred">ย้ายห้อง (Transferred)</option>
                  </select>
                </div>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button type="button" onClick={() => setShowEditStudentModal(null)} className="btn btn-outline">ยกเลิก</button>
                <button type="submit" className="btn btn-primary">💾 บันทึกแก้ไข</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL 3: Add Subject Modal */}
      {showAddSubjectModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '480px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>📚 เพิ่มวิชาเรียนใหม่รายบุคคล</h3>
            <form onSubmit={handleAddSubject} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label" htmlFor="subCodeInput">รหัสวิชา</label>
                <input id="subCodeInput" type="text" placeholder="เช่น ค21101" className="input-field" value={subCode} onChange={(e) => setSubCode(e.target.value)} required />
              </div>
              <div>
                <label className="input-label" htmlFor="subNameInput">ชื่อรายวิชา</label>
                <input id="subNameInput" type="text" placeholder="เช่น คณิตศาสตร์พื้นฐาน 1" className="input-field" value={subName} onChange={(e) => setSubName(e.target.value)} required />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="input-label" htmlFor="subCreditsInput">หน่วยกิต</label>
                  <input id="subCreditsInput" type="number" step="0.5" className="input-field" value={subCredits} onChange={(e) => setSubCredits(Number(e.target.value))} required />
                </div>
                <div>
                  <label className="input-label" htmlFor="subGradeInput">ระดับชั้น (ปีการศึกษา)</label>
                  <input id="subGradeInput" type="number" className="input-field" value={subGradeLevel} onChange={(e) => setSubGradeLevel(Number(e.target.value))} required />
                </div>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button type="button" onClick={() => setShowAddSubjectModal(false)} className="btn btn-outline">ยกเลิก</button>
                <button type="submit" className="btn btn-primary">✓ บันทึกรายวิชา</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL: Edit Subject Modal */}
      {showEditSubjectModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '480px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>✏️ แก้ไขข้อมูลวิชาเรียน</h3>
            <form onSubmit={handleUpdateSubject} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label" htmlFor="editSubCode">รหัสวิชา</label>
                <input 
                  id="editSubCode" 
                  type="text" 
                  className="input-field" 
                  value={showEditSubjectModal.code} 
                  onChange={(e) => setShowEditSubjectModal({ ...showEditSubjectModal, code: e.target.value })} 
                  required 
                />
              </div>
              <div>
                <label className="input-label" htmlFor="editSubName">ชื่อรายวิชา</label>
                <input 
                  id="editSubName" 
                  type="text" 
                  className="input-field" 
                  value={showEditSubjectModal.name} 
                  onChange={(e) => setShowEditSubjectModal({ ...showEditSubjectModal, name: e.target.value })} 
                  required 
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="input-label" htmlFor="editSubCredits">หน่วยกิต</label>
                  <input 
                    id="editSubCredits" 
                    type="number" 
                    step="0.5" 
                    className="input-field" 
                    value={showEditSubjectModal.credits || 1.5} 
                    onChange={(e) => setShowEditSubjectModal({ ...showEditSubjectModal, credits: Number(e.target.value) })} 
                    required 
                  />
                </div>
                <div>
                  <label className="input-label" htmlFor="editSubGrade">ระดับชั้น (ปีการศึกษา)</label>
                  <select 
                    id="editSubGrade" 
                    className="input-field" 
                    value={showEditSubjectModal.grade_level || 7} 
                    onChange={(e) => setShowEditSubjectModal({ ...showEditSubjectModal, grade_level: Number(e.target.value) })} 
                    style={{ background: 'var(--bg-input)' }}
                    required
                  >
                    <option value={7}>ม.1</option>
                    <option value={8}>ม.2</option>
                    <option value={9}>ม.3</option>
                    <option value={10}>ม.4</option>
                    <option value={11}>ม.5</option>
                    <option value={12}>ม.6</option>
                    <option value={20}>ม.ต้น (ทั่วไป)</option>
                    <option value={30}>ม.ปลาย (ทั่วไป)</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="input-label" htmlFor="editSubDept">กลุ่มสาระการเรียนรู้</label>
                <select 
                  id="editSubDept" 
                  className="input-field" 
                  value={showEditSubjectModal.department_id || 1} 
                  onChange={(e) => setShowEditSubjectModal({ ...showEditSubjectModal, department_id: Number(e.target.value) })} 
                  style={{ background: 'var(--bg-input)' }}
                  required
                >
                  {departments.map(d => (
                    <option key={d.id} value={d.id}>{d.name}</option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button type="button" onClick={() => setShowEditSubjectModal(null)} className="btn btn-outline">ยกเลิก</button>
                <button type="submit" className="btn btn-primary">💾 บันทึกแก้ไข</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL: Bulk Classroom Edit Modal */}
      {showBulkClassroomModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '500px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '8px' }}>🚀 จัดการข้อมูลแบบรายห้องเรียน (Bulk Edit)</h3>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '20px' }}>
              ทำรายการอัปเดตข้อมูลนักเรียนทั้งห้องเรียนพร้อมกัน เช่น เลื่อนชั้นเรียน หรือเปลี่ยนประเภทห้องเรียน
            </p>
            <form onSubmit={handleBulkClassroomEdit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>

                <label className="input-label" style={{ marginBottom: '8px' }}>1. ขอบเขตห้องเรียนต้นทาง</label>
                <div style={{ display: 'flex', gap: '16px', marginBottom: '12px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                    <input 
                      type="radio" 
                      name="bulkScope" 
                      value="single" 
                      checked={bulkScope === 'single'} 
                      onChange={() => { setBulkScope('single'); setBulkSelectedRooms([]); }} 
                    />
                    รายห้องเรียนเดี่ยว
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                    <input 
                      type="radio" 
                      name="bulkScope" 
                      value="multiple" 
                      checked={bulkScope === 'multiple'} 
                      onChange={() => { setBulkScope('multiple'); setBulkSrcRoom(''); }} 
                    />
                    เลือกหลายห้องเรียน
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
                    <input 
                      type="radio" 
                      name="bulkScope" 
                      value="grade" 
                      checked={bulkScope === 'grade'} 
                      onChange={() => { setBulkScope('grade'); setBulkSrcRoom(''); setBulkSelectedRooms([]); }} 
                    />
                    ทั้งระดับชั้นเรียน
                  </label>
                </div>

                {bulkScope === 'single' && (
                  <>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div>
                        <label className="input-label" htmlFor="bulkSrcGrade" style={{ fontSize: '11px', fontWeight: 'normal' }}>ระดับชั้นเรียน</label>
                        <select 
                          id="bulkSrcGrade" 
                          className="input-field" 
                          value={bulkSrcGrade} 
                          onChange={(e) => setBulkSrcGrade(e.target.value)} 
                          style={{ background: 'var(--bg-input)' }}
                          required
                        >
                          <option value="">-- เลือกชั้น --</option>
                          <option value="7">ม.1</option>
                          <option value="8">ม.2</option>
                          <option value="9">ม.3</option>
                          <option value="10">ม.4</option>
                          <option value="11">ม.5</option>
                          <option value="12">ม.6</option>
                        </select>
                      </div>
                      <div>
                        <label className="input-label" htmlFor="bulkSrcRoom" style={{ fontSize: '11px', fontWeight: 'normal' }}>ห้องเรียน</label>
                        <select 
                          id="bulkSrcRoom" 
                          className="input-field" 
                          value={bulkSrcRoom} 
                          onChange={(e) => setBulkSrcRoom(e.target.value)} 
                          style={{ background: 'var(--bg-input)' }}
                          required
                        >
                          <option value="">-- เลือกห้อง --</option>
                          {Array.from({ length: 26 }, (_, i) => String(i + 1)).map(room => (
                            <option key={room} value={room}>ห้อง {room}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {(() => {
                      const srcClass = classrooms.find(c => c.grade_level === Number(bulkSrcGrade) && c.room_number === bulkSrcRoom)
                      const srcCount = srcClass ? students.filter(s => s.classroom_id === srcClass.id).length : 0
                      return bulkSrcGrade && bulkSrcRoom ? (
                        <div style={{ fontSize: '12px', marginTop: '8px', color: 'var(--primary)', fontWeight: '600' }}>
                          🟢 จำนวนนักเรียนปัจจุบันในห้องนี้: {srcCount} คน
                        </div>
                      ) : null
                    })()}
                  </>
                )}

                {bulkScope === 'grade' && (
                  <>
                    <div>
                      <label className="input-label" htmlFor="bulkSrcGradeOnly">ระดับชั้นเรียนต้นทาง</label>
                      <select 
                        id="bulkSrcGradeOnly" 
                        className="input-field" 
                        value={bulkSrcGrade} 
                        onChange={(e) => setBulkSrcGrade(e.target.value)} 
                        style={{ background: 'var(--bg-input)' }}
                        required
                      >
                        <option value="">-- เลือกชั้น --</option>
                        <option value="7">ม.1</option>
                        <option value="8">ม.2</option>
                        <option value="9">ม.3</option>
                        <option value="10">ม.4</option>
                        <option value="11">ม.5</option>
                        <option value="12">ม.6</option>
                      </select>
                    </div>
                    {(() => {
                      const srcClassrooms = classrooms.filter(c => c.grade_level === Number(bulkSrcGrade))
                      const srcClassroomIds = srcClassrooms.map(c => c.id)
                      const srcCount = students.filter(s => srcClassroomIds.includes(s.classroom_id)).length
                      return bulkSrcGrade ? (
                        <div style={{ fontSize: '12px', marginTop: '8px', color: 'var(--primary)', fontWeight: '600' }}>
                          🟢 จำนวนนักเรียนรวมในระดับชั้นนี้ ({srcClassrooms.length} ห้อง): {srcCount} คน
                        </div>
                      ) : null
                    })()}
                  </>
                )}

                {bulkScope === 'multiple' && (
                  <>
                    <div>
                      <label className="input-label" htmlFor="bulkSrcGradeMulti">ระดับชั้นเรียนต้นทาง</label>
                      <select 
                        id="bulkSrcGradeMulti" 
                        className="input-field" 
                        value={bulkSrcGrade} 
                        onChange={(e) => { setBulkSrcGrade(e.target.value); setBulkSelectedRooms([]); }} 
                        style={{ background: 'var(--bg-input)', marginBottom: '12px' }}
                        required
                      >
                        <option value="">-- เลือกชั้น --</option>
                        <option value="7">ม.1</option>
                        <option value="8">ม.2</option>
                        <option value="9">ม.3</option>
                        <option value="10">ม.4</option>
                        <option value="11">ม.5</option>
                        <option value="12">ม.6</option>
                      </select>
                    </div>
                    
                    {bulkSrcGrade && (
                      <div>
                        <label className="input-label" style={{ fontSize: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                          <span>เลือกห้องเรียน (ติ๊กถูกห้องที่ต้องการ)</span>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button 
                              type="button" 
                              onClick={() => setBulkSelectedRooms(Array.from({ length: 26 }, (_, i) => String(i + 1)))} 
                              style={{ background: 'transparent', border: 'none', color: 'var(--primary)', fontSize: '11px', cursor: 'pointer', padding: 0 }}
                            >
                              [เลือกทั้งหมด]
                            </button>
                            <button 
                              type="button" 
                              onClick={() => setBulkSelectedRooms([])} 
                              style={{ background: 'transparent', border: 'none', color: 'var(--danger)', fontSize: '11px', cursor: 'pointer', padding: 0 }}
                            >
                              [ล้างทั้งหมด]
                            </button>
                          </div>
                        </label>
                        <div style={{ 
                          display: 'grid', 
                          gridTemplateColumns: 'repeat(4, 1fr)', 
                          gap: '8px', 
                          maxHeight: '120px', 
                          overflowY: 'auto', 
                          border: '1px solid var(--border)', 
                          borderRadius: '8px', 
                          padding: '10px', 
                          background: 'var(--bg-input)' 
                        }}>
                          {Array.from({ length: 26 }, (_, i) => String(i + 1)).map(room => {
                            const isChecked = bulkSelectedRooms.includes(room)
                            return (
                              <label key={room} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', cursor: 'pointer' }}>
                                <input 
                                  type="checkbox" 
                                  checked={isChecked} 
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setBulkSelectedRooms([...bulkSelectedRooms, room])
                                    } else {
                                      setBulkSelectedRooms(bulkSelectedRooms.filter(r => r !== room))
                                    }
                                  }} 
                                />
                                ห้อง {room}
                              </label>
                            )
                          })}
                        </div>
                        {(() => {
                          const srcClassrooms = classrooms.filter(c => c.grade_level === Number(bulkSrcGrade) && bulkSelectedRooms.includes(c.room_number))
                          const srcClassroomIds = srcClassrooms.map(c => c.id)
                          const srcCount = students.filter(s => srcClassroomIds.includes(s.classroom_id)).length
                          return (
                            <div style={{ fontSize: '12px', marginTop: '8px', color: 'var(--primary)', fontWeight: '600' }}>
                              🟢 เลือกห้องเรียนแล้ว: {bulkSelectedRooms.length} ห้อง (นักเรียนรวม {srcCount} คน)
                            </div>
                          )
                        })()}
                      </div>
                    )}
                  </>
                )}
              </div>

              <div>
                <label className="input-label">2. เลือกประเภทการทำงาน</label>
                <div style={{ display: 'flex', gap: '16px', marginTop: '6px' }}>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                    <input 
                      type="radio" 
                      name="bulkActionType" 
                      value="move" 
                      checked={bulkActionType === 'move'} 
                      onChange={() => setBulkActionType('move')} 
                    />
                    ย้ายห้องเรียนยกห้อง (เลื่อนชั้น)
                  </label>
                  <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                    <input 
                      type="radio" 
                      name="bulkActionType" 
                      value="room_type" 
                      checked={bulkActionType === 'room_type'} 
                      onChange={() => setBulkActionType('room_type')} 
                    />
                    เปลี่ยนประเภทห้องเรียนยกห้อง
                  </label>
                </div>
              </div>

              {bulkActionType === 'move' ? (
                <div>
                  <label className="input-label">3. เลือกห้องเรียนปลายทาง</label>
                  {bulkScope === 'grade' ? (
                    <div>
                      <label className="input-label" htmlFor="bulkDestGrade" style={{ fontSize: '11px', fontWeight: 'normal' }}>ระดับชั้นเรียนปลายทาง</label>
                      <select 
                        id="bulkDestGrade" 
                        className="input-field" 
                        value={bulkDestGrade} 
                        onChange={(e) => setBulkDestGrade(e.target.value)} 
                        style={{ background: 'var(--bg-input)' }}
                        required
                      >
                        <option value="">-- เลือกชั้น --</option>
                        <option value="7">ม.1</option>
                        <option value="8">ม.2</option>
                        <option value="9">ม.3</option>
                        <option value="10">ม.4</option>
                        <option value="11">ม.5</option>
                        <option value="12">ม.6</option>
                      </select>
                      <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '8px', background: 'rgba(79, 70, 229, 0.05)', padding: '8px 12px', borderRadius: '8px', borderLeft: '3px solid var(--primary)' }}>
                        💡 <strong>ระบบจะเลื่อนชั้นทั้งระดับชั้นเรียนคู่ขนาน:</strong> นักเรียนแต่ละห้องจะย้ายไปยังระดับชั้นเรียนปลายทางโดยใช้เลขห้องเรียนตรงกันเดิมอัตโนมัติ (เช่น ม.1/1 ➡️ ม.2/1, ม.1/2 ➡️ ม.2/2)
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                      <div>
                        <label className="input-label" htmlFor="bulkDestGrade" style={{ fontSize: '11px', fontWeight: 'normal' }}>ระดับชั้นเรียน</label>
                        <select 
                          id="bulkDestGrade" 
                          className="input-field" 
                          value={bulkDestGrade} 
                          onChange={(e) => setBulkDestGrade(e.target.value)} 
                          style={{ background: 'var(--bg-input)' }}
                          required
                        >
                          <option value="">-- เลือกชั้น --</option>
                          <option value="7">ม.1</option>
                          <option value="8">ม.2</option>
                          <option value="9">ม.3</option>
                          <option value="10">ม.4</option>
                          <option value="11">ม.5</option>
                          <option value="12">ม.6</option>
                        </select>
                      </div>
                      <div>
                        <label className="input-label" htmlFor="bulkDestRoom" style={{ fontSize: '11px', fontWeight: 'normal' }}>ห้องเรียน</label>
                        <select 
                          id="bulkDestRoom" 
                          className="input-field" 
                          value={bulkDestRoom} 
                          onChange={(e) => setBulkDestRoom(e.target.value)} 
                          style={{ background: 'var(--bg-input)' }}
                          required
                        >
                          <option value="">-- เลือกห้อง --</option>
                          {Array.from({ length: 26 }, (_, i) => String(i + 1)).map(room => (
                            <option key={room} value={room}>ห้อง {room}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <label className="input-label" htmlFor="bulkDestRoomType">3. เลือกประเภทห้องเรียนเป้าหมาย</label>
                  <select 
                    id="bulkDestRoomType" 
                    className="input-field" 
                    value={bulkDestRoomType} 
                    onChange={(e) => setBulkDestRoomType(e.target.value)} 
                    style={{ background: 'var(--bg-input)' }}
                    required
                  >
                    {roomTypes.map(t => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </select>
                </div>
              )}

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '16px' }}>
                <button type="button" onClick={() => setShowBulkClassroomModal(false)} className="btn btn-outline">ยกเลิก</button>
                <button type="submit" className="btn btn-primary">🚀 ดำเนินการแบบกลุ่ม</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL 4: Create Classroom Type Modal */}
      {showRoomTypeModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '460px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>🏫 จัดการประเภทห้องเรียน</h3>
            
            {/* List existing classroom types */}
            <div style={{ maxHeight: '180px', overflowY: 'auto', marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {roomTypes.map((type) => (
                <div key={type} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: 'var(--bg-card)', borderRadius: '8px', border: '1px solid var(--border)' }}>
                  {editingRoomTypeVal === type ? (
                    <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                      <input 
                        type="text" 
                        className="input-field" 
                        value={editingRoomTypeInput} 
                        onChange={(e) => setEditingRoomTypeInput(e.target.value)} 
                        style={{ padding: '4px 8px', fontSize: '13px' }}
                        required 
                      />
                      <button type="button" onClick={() => handleSaveEditRoomType(type)} className="btn btn-primary" style={{ padding: '4px 10px', fontSize: '12px' }}>✓</button>
                      <button type="button" onClick={() => setEditingRoomTypeVal(null)} className="btn btn-outline" style={{ padding: '4px 10px', fontSize: '12px' }}>✕</button>
                    </div>
                  ) : (
                    <>
                      <span style={{ color: '#000000' }}>{type}</span>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button 
                          type="button" 
                          onClick={() => { setEditingRoomTypeVal(type); setEditingRoomTypeInput(type); }} 
                          className="btn btn-outline" 
                          style={{ padding: '4px 8px', fontSize: '11px', color: 'var(--primary)' }}
                        >
                          ✏️ แก้ไข
                        </button>
                        <button 
                          type="button" 
                          onClick={() => handleDeleteRoomType(type)} 
                          className="btn btn-outline" 
                          style={{ padding: '4px 8px', fontSize: '11px', color: 'var(--danger)', borderColor: 'rgba(239,68,68,0.15)' }}
                        >
                          🗑️ ลบ
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
              {roomTypes.length === 0 && <span style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>ไม่มีข้อมูลประเภทห้องเรียน</span>}
            </div>

            <form onSubmit={handleAddRoomType} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label" htmlFor="newRoomTypeInput">ชื่อประเภทห้องเรียนใหม่</label>
                <input id="newRoomTypeInput" type="text" placeholder="เช่น Gifted, EP, SME..." className="input-field" value={newRoomTypeVal} onChange={(e) => setNewRoomTypeVal(e.target.value)} required />
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button type="button" onClick={() => setShowRoomTypeModal(false)} className="btn btn-outline">ปิดหน้าจอ</button>
                <button type="submit" className="btn btn-primary">✓ บันทึกประเภทห้อง</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL 5: Add Teaching Assignment Modal */}
      {showAddAssignmentModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '480px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>✏️ มอบหมายงานสอนใหม่</h3>
            <form onSubmit={handleAddAssignment} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label" htmlFor="assignTeacherSelect">เลือกครูผู้สอน</label>
                <select 
                  id="assignTeacherSelect"
                  className="input-field" 
                  value={assignTeacherId} 
                  onChange={(e) => setAssignTeacherId(e.target.value)}
                  style={{ background: 'var(--bg-input)' }}
                  required
                >
                  <option value="">-- เลือกครูผู้สอน --</option>
                  {teachers.map(t => {
                    const roleLabel = t.role === 'head_of_department' ? 'หัวหน้าสาระ' : t.role === 'admin' ? 'แอดมิน' : 'ครู'
                    return <option key={t.id} value={t.id}>{t.first_name} {t.last_name} ({roleLabel})</option>
                  })}
                </select>
              </div>

              <div>
                <label className="input-label" htmlFor="assignSubjectSelect">เลือกรายวิชา</label>
                <select 
                  id="assignSubjectSelect"
                  className="input-field" 
                  value={assignSubjectId} 
                  onChange={(e) => setAssignSubjectId(e.target.value)}
                  style={{ background: 'var(--bg-input)' }}
                  required
                >
                  <option value="">-- เลือกรายวิชา --</option>
                  {subjects.map(s => (
                    <option key={s.id} value={s.id}>[{s.code}] {s.name}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="input-label">🔍 กรองห้องเรียน (ชั้น / ห้อง)</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '8px' }}>
                  <select
                    className="input-field"
                    value={assignClassroomFilterGrade}
                    onChange={(e) => { setAssignClassroomFilterGrade(e.target.value); setAssignClassroomId('') }}
                    style={{ background: 'var(--bg-input)', fontSize: '13px' }}
                  >
                    <option value="all">ทุกชั้น</option>
                    {[1,2,3,4,5,6].map(g => <option key={g} value={String(g + 6)}>ม.{g}</option>)}
                  </select>
                  <input
                    type="text"
                    className="input-field"
                    placeholder="ห้อง เช่น 1, 2, 3..."
                    value={assignClassroomFilterRoom}
                    onChange={(e) => { setAssignClassroomFilterRoom(e.target.value); setAssignClassroomId('') }}
                    style={{ background: 'var(--bg-input)', fontSize: '13px' }}
                  />
                </div>
                <label className="input-label" htmlFor="assignClassroomSelect">เลือกห้องเรียน</label>
                <select 
                  id="assignClassroomSelect"
                  className="input-field" 
                  value={assignClassroomId} 
                  onChange={(e) => setAssignClassroomId(e.target.value)}
                  style={{ background: 'var(--bg-input)' }}
                  required
                >
                  <option value="">-- เลือกห้องเรียน --</option>
                  {[...classrooms]
                    .filter(c => {
                      const gradeOk = assignClassroomFilterGrade === 'all' || String(c.grade_level) === assignClassroomFilterGrade
                      const roomOk = !assignClassroomFilterRoom.trim() || c.room_number.includes(assignClassroomFilterRoom.trim())
                      return gradeOk && roomOk
                    })
                    .sort((a, b) => a.grade_level - b.grade_level || a.room_number.localeCompare(b.room_number, undefined, { numeric: true }))
                    .map(c => {
                      const g = c.grade_level >= 7 && c.grade_level <= 12 ? c.grade_level - 6 : c.grade_level
                      return <option key={c.id} value={c.id}>ม.{g}/{c.room_number}</option>
                    })}
                </select>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '4px' }}>
                <button type="button" onClick={() => { setShowAddAssignmentModal(false); setAssignClassroomFilterGrade('all'); setAssignClassroomFilterRoom('') }} className="btn btn-outline">ยกเลิก</button>
                <button type="submit" className="btn btn-primary">💾 บันทึกการมอบหมาย</button>
              </div>
            </form>
          </div>
        </div>
      )}


      {/* MODAL 5b: Edit Assignment Modal */}
      {showEditAssignmentModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '480px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>✏️ แก้ไขการมอบหมายงานสอน</h3>
            <form onSubmit={handleUpdateAssignment} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label">เลือกครูผู้สอน</label>
                <select
                  className="input-field"
                  value={editAssignTeacherId}
                  onChange={(e) => setEditAssignTeacherId(e.target.value)}
                  style={{ background: 'var(--bg-input)' }}
                  required
                >
                  <option value="">-- เลือกครูผู้สอน --</option>
                  {teachers.map(t => {
                    const roleLabel = t.role === 'head_of_department' ? 'หัวหน้าสาระ' : t.role === 'admin' ? 'แอดมิน' : 'ครู'
                    return <option key={t.id} value={t.id}>{t.first_name} {t.last_name} ({roleLabel})</option>
                  })}
                </select>
              </div>

              <div>
                <label className="input-label">เลือกรายวิชา</label>
                <select
                  className="input-field"
                  value={editAssignSubjectId}
                  onChange={(e) => setEditAssignSubjectId(e.target.value)}
                  style={{ background: 'var(--bg-input)' }}
                  required
                >
                  <option value="">-- เลือกรายวิชา --</option>
                  {subjects.map(s => (
                    <option key={s.id} value={s.id}>[{s.code}] {s.name}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="input-label">🔍 กรองห้องเรียน (ชั้น / ห้อง)</label>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '8px' }}>
                  <select
                    className="input-field"
                    value={editAssignClassroomFilterGrade}
                    onChange={(e) => { setEditAssignClassroomFilterGrade(e.target.value); setEditAssignClassroomId('') }}
                    style={{ background: 'var(--bg-input)', fontSize: '13px' }}
                  >
                    <option value="all">ทุกชั้น</option>
                    {[1,2,3,4,5,6].map(g => <option key={g} value={String(g + 6)}>ม.{g}</option>)}
                  </select>
                  <input
                    type="text"
                    className="input-field"
                    placeholder="ห้อง เช่น 1, 2, 3..."
                    value={editAssignClassroomFilterRoom}
                    onChange={(e) => { setEditAssignClassroomFilterRoom(e.target.value); setEditAssignClassroomId('') }}
                    style={{ background: 'var(--bg-input)', fontSize: '13px' }}
                  />
                </div>
                <label className="input-label">เลือกห้องเรียน</label>
                <select
                  className="input-field"
                  value={editAssignClassroomId}
                  onChange={(e) => setEditAssignClassroomId(e.target.value)}
                  style={{ background: 'var(--bg-input)' }}
                  required
                >
                  <option value="">-- เลือกห้องเรียน --</option>
                  {[...classrooms]
                    .filter(c => {
                      const gradeOk = editAssignClassroomFilterGrade === 'all' || String(c.grade_level) === editAssignClassroomFilterGrade
                      const roomOk = !editAssignClassroomFilterRoom.trim() || c.room_number.includes(editAssignClassroomFilterRoom.trim())
                      return gradeOk && roomOk
                    })
                    .sort((a, b) => a.grade_level - b.grade_level || a.room_number.localeCompare(b.room_number, undefined, { numeric: true }))
                    .map(c => {
                      const g = c.grade_level >= 7 && c.grade_level <= 12 ? c.grade_level - 6 : c.grade_level
                      return <option key={c.id} value={c.id}>ม.{g}/{c.room_number}</option>
                    })}
                </select>
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '4px' }}>
                <button type="button" onClick={() => { setShowEditAssignmentModal(false); setEditAssignId(null); setEditAssignClassroomFilterGrade('all'); setEditAssignClassroomFilterRoom('') }} className="btn btn-outline">ยกเลิก</button>
                <button type="submit" className="btn btn-primary">💾 บันทึกการแก้ไข</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL 6: Manage Department Modal */}
      {showDepartmentModal && (
        <div className="modal-overlay">
          <div className="glassmorphism modal-box" style={{ maxWidth: '500px' }}>
            <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '16px' }}>🏫 จัดการกลุ่มสาระการเรียนรู้</h3>
            
            {/* List existing departments */}
            <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {departments.map((dept) => (
                <div key={dept.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: 'var(--bg-card)', borderRadius: '8px', border: '1px solid var(--border)' }}>
                  {editingDeptId === dept.id ? (
                    <div style={{ display: 'flex', gap: '8px', width: '100%' }}>
                      <input 
                        type="text" 
                        className="input-field" 
                        value={editingDeptVal} 
                        onChange={(e) => setEditingDeptVal(e.target.value)} 
                        style={{ padding: '4px 8px', fontSize: '13px' }}
                        required 
                      />
                      <button type="button" onClick={() => handleSaveEditDept(dept.id)} className="btn btn-primary" style={{ padding: '4px 10px', fontSize: '12px' }}>✓</button>
                      <button type="button" onClick={() => setEditingDeptId(null)} className="btn btn-outline" style={{ padding: '4px 10px', fontSize: '12px' }}>✕</button>
                    </div>
                  ) : (
                    <>
                      <span style={{ color: '#000000' }}>{dept.name}</span>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button 
                          type="button" 
                          onClick={() => { setEditingDeptId(dept.id); setEditingDeptVal(dept.name); }} 
                          className="btn btn-outline" 
                          style={{ padding: '4px 8px', fontSize: '11px', color: 'var(--primary)' }}
                        >
                          ✏️ แก้ไข
                        </button>
                        <button 
                          type="button" 
                          onClick={() => handleDeleteDepartment(dept.id)} 
                          className="btn btn-outline" 
                          style={{ padding: '4px 8px', fontSize: '11px', color: 'var(--danger)', borderColor: 'rgba(239,68,68,0.15)' }}
                        >
                          🗑️ ลบ
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
              {departments.length === 0 && <span style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>ไม่มีข้อมูลกลุ่มสาระฯ</span>}
            </div>

            <form onSubmit={handleAddDepartment} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label className="input-label" htmlFor="newDeptNameInput">ชื่อกลุ่มสาระใหม่</label>
                <input id="newDeptNameInput" type="text" placeholder="เช่น คณิตศาสตร์, วิทยาศาสตร์..." className="input-field" value={newDeptNameVal} onChange={(e) => setNewDeptNameVal(e.target.value)} required />
              </div>

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button type="button" onClick={() => setShowDepartmentModal(false)} className="btn btn-outline">ปิดหน้าจอ</button>
                <button type="submit" className="btn btn-primary">✓ บันทึกกลุ่มสาระ</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL 7: Excel Verification & Preview Modal */}
      {showImportPreviewModal && importValidationReport && stagedRows && (
        <div className="modal-overlay" style={{ zIndex: 110 }}>
          <div className="glassmorphism modal-box" style={{ maxWidth: '800px', display: 'flex', flexDirection: 'column', gap: '20px' }}>

            <div>
              <h3 style={{ fontSize: '20px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>
                🔍 ตรวจสอบความถูกต้องและจำลองข้อมูลก่อนนำเข้า ({stagedImportType === 'students' ? 'รายชื่อนักเรียน' : 'วิชาเรียน'})
              </h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '8px' }}>
                <span style={{ fontSize: '13px', padding: '4px 12px', background: 'rgba(79,70,229,0.1)', color: 'var(--primary)', borderRadius: '20px', fontWeight: '600' }}>
                  🎯 ภาคเรียนเป้าหมาย: {academicYears.find(y => y.id === selectedYearId) ? `ภาคเรียนที่ ${academicYears.find(y => y.id === selectedYearId).semester}/${academicYears.find(y => y.id === selectedYearId).year}` : '—'}
                </span>
              </div>
              <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>ระบบทำการจำลองและตรวจสอบข้อมูลกับฐานข้อมูลแบบเรียลไทม์ โปรดตรวจสอบรายงานสรุปความถูกต้องด้านล่าง</p>
            </div>

            {/* Validation Metrics Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))', gap: '12px' }}>
              <div style={{ background: '#f8fafc', padding: '12px', borderRadius: '8px', border: '1px solid var(--border)', textAlign: 'center' }}>
                <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>ข้อมูลทั้งหมด</div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: 'var(--text-primary)' }}>{importValidationReport.total}</div>
              </div>
              <div style={{ background: 'rgba(34,197,94,0.06)', padding: '12px', borderRadius: '8px', border: '1px solid rgba(34,197,94,0.2)', textAlign: 'center' }}>
                <div style={{ fontSize: '12px', color: 'green' }}>เพิ่มรายใหม่</div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: 'green' }}>{importValidationReport.valid}</div>
              </div>
              <div style={{ background: 'rgba(59,130,246,0.06)', padding: '12px', borderRadius: '8px', border: '1px solid rgba(59,130,246,0.2)', textAlign: 'center' }}>
                <div style={{ fontSize: '12px', color: 'var(--primary)' }}>ปรับปรุงข้อมูล</div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: 'var(--primary)' }}>{importValidationReport.update || 0}</div>
              </div>
              <div style={{ background: 'rgba(234,179,8,0.06)', padding: '12px', borderRadius: '8px', border: '1px solid rgba(234,179,8,0.2)', textAlign: 'center' }}>
                <div style={{ fontSize: '12px', color: '#b45309' }}>ข้อมูลเดิม (จะอัปเดต)</div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#b45309' }}>{importValidationReport.duplicate}</div>
              </div>
              <div style={{ background: 'rgba(239,68,68,0.06)', padding: '12px', borderRadius: '8px', border: '1px solid rgba(239,68,68,0.2)', textAlign: 'center' }}>
                <div style={{ fontSize: '12px', color: 'red' }}>ไม่สมบูรณ์ (ข้าม)</div>
                <div style={{ fontSize: '18px', fontWeight: '700', color: 'red' }}>{importValidationReport.error}</div>
              </div>
            </div>

            {/* New Classrooms & Room Types Warning (For Students) */}
            {stagedImportType === 'students' && (importValidationReport.newClassrooms.length > 0 || (importValidationReport.newRoomTypes && importValidationReport.newRoomTypes.length > 0)) && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {importValidationReport.newClassrooms.length > 0 && (
                  <div style={{ background: 'rgba(59,130,246,0.06)', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(59,130,246,0.2)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <strong style={{ fontSize: '13px', color: 'var(--primary)' }}>💡 ค้นพบห้องเรียนใหม่ในไฟล์ Excel:</strong>
                    <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                      ระบบจะทำการสร้างห้องเรียนเหล่านี้ขึ้นมาโดยอัตโนมัติก่อนนำเข้านักเรียน: {importValidationReport.newClassrooms.join(', ')}
                    </span>
                  </div>
                )}
                {importValidationReport.newRoomTypes && importValidationReport.newRoomTypes.length > 0 && (
                  <div style={{ background: 'rgba(147,51,234,0.06)', padding: '12px 16px', borderRadius: '8px', border: '1px solid rgba(147,51,234,0.2)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <strong style={{ fontSize: '13px', color: 'var(--secondary)' }}>✨ ค้นพบประเภทห้องเรียนใหม่ในไฟล์ Excel:</strong>
                    <span style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                      ระบบจะทำการเพิ่มประเภทห้องเรียนเหล่านี้เข้าระบบโดยอัตโนมัติ: {importValidationReport.newRoomTypes.join(', ')}
                    </span>
                  </div>
                )}
              </div>
            )}

            {/* Preview Simulation Table */}
            <div style={{ flex: 1, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: '8px', maxHeight: '350px' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', textAlign: 'left' }}>
                <thead>
                  <tr style={{ background: '#f8fafc', borderBottom: '1px solid var(--border)', color: 'var(--text-secondary)' }}>
                    <th style={{ padding: '10px 16px' }}>ลำดับ</th>
                    {stagedImportType === 'students' ? (
                      <>
                        <th style={{ padding: '10px 16px' }}>รหัสประจำตัว</th>
                        <th style={{ padding: '10px 16px' }}>ชื่อ-นามสกุล</th>
                        <th style={{ padding: '10px 16px' }}>ห้องเรียน</th>
                        <th style={{ padding: '10px 16px' }}>เลขที่</th>
                      </>
                    ) : (
                      <>
                        <th style={{ padding: '10px 16px' }}>รหัสวิชา</th>
                        <th style={{ padding: '10px 16px' }}>ชื่อวิชา</th>
                        <th style={{ padding: '10px 16px' }}>หน่วยกิต</th>
                        <th style={{ padding: '10px 16px' }}>ระดับชั้น</th>
                        <th style={{ padding: '10px 16px' }}>กลุ่มสาระ</th>
                      </>
                    )}
                    <th style={{ padding: '10px 16px' }}>สถานะ/ผลจำลอง</th>
                  </tr>
                </thead>
                <tbody>
                  {stagedRows.map((row, idx) => {
                    let statusColor = '#22c55e'
                    let statusBg = 'rgba(34,197,94,0.1)'
                    let statusLabel = 'พร้อมนำเข้า (รายใหม่)'

                    if (row.status === 'update') {
                      statusColor = 'var(--primary)'
                      statusBg = 'rgba(59,130,246,0.1)'
                      statusLabel = row.errorMsg || 'ปรับปรุงข้อมูล (จะแก้ไขข้อมูลเดิม)'
                    } else if (row.status === 'duplicate') {
                      statusColor = '#eab308'
                      statusBg = 'rgba(234,179,8,0.1)'
                      statusLabel = 'ข้าม (ข้อมูลในระบบตรงกันแล้ว)'
                    } else if (row.status === 'error') {
                      statusColor = '#ef4444'
                      statusBg = 'rgba(239,68,68,0.1)'
                      statusLabel = row.errorMsg || 'ข้อมูลไม่สมบูรณ์'
                    }

                    return (
                      <tr key={row.id} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '10px 16px', color: 'var(--text-muted)' }}>{idx + 1}</td>
                        {stagedImportType === 'students' ? (
                          <>
                            <td style={{ padding: '10px 16px', fontWeight: '500' }}>{row.data.student_id_card || '—'}</td>
                            <td style={{ padding: '10px 16px' }}>{row.data.title}{row.data.first_name} {row.data.last_name}</td>
                            <td style={{ padding: '10px 16px' }}>ม.{row.data.grade_and_room}</td>
                            <td style={{ padding: '10px 16px' }}>{row.data.number_in_class}</td>
                          </>
                        ) : (
                          <>
                            <td style={{ padding: '10px 16px', fontWeight: '500' }}>{row.data.code || '—'}</td>
                            <td style={{ padding: '10px 16px' }}>{row.data.name}</td>
                            <td style={{ padding: '10px 16px' }}>{row.data.credits}</td>
                            <td style={{ padding: '10px 16px' }}>{getSubjectGradeStr(row.data.grade_level)}</td>
                            <td style={{ padding: '10px 16px' }}>{departments.find(d => d.id === row.data.department_id)?.name || row.data.department_name || '—'}</td>
                          </>
                        )}
                        <td style={{ padding: '10px 16px' }}>
                          <span style={{
                            padding: '2px 8px',
                            borderRadius: '12px',
                            fontSize: '11px',
                            fontWeight: '600',
                            color: statusColor,
                            background: statusBg,
                            display: 'inline-block'
                          }}>
                            {statusLabel}
                          </span>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>

            {/* Dynamic Progress Bar */}
            {isSavingImport && importProgress && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: 'var(--text-secondary)' }}>
                  <span>🚀 กำลังส่งข้อมูลไปยังฐานข้อมูล...</span>
                  <span>{importProgress.current}/{importProgress.total} รายการ ({Math.round((importProgress.current / importProgress.total) * 100)}%)</span>
                </div>
                <div style={{ width: '100%', height: '8px', background: '#e2e8f0', borderRadius: '4px', overflow: 'hidden' }}>
                  <div style={{ width: `${(importProgress.current / importProgress.total) * 100}%`, height: '100%', background: 'var(--primary)', transition: 'width 0.1s ease-in-out' }} />
                </div>
              </div>
            )}

            {/* Bottom Actions */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', borderTop: '1px solid var(--border)', paddingTop: '16px' }}>
              <button 
                type="button" 
                onClick={() => {
                  setShowImportPreviewModal(false)
                  setStagedRows(null)
                  setImportValidationReport(null)
                  setStagedImportType(null)
                }} 
                className="btn btn-outline"
                disabled={isSavingImport}
              >
                ยกเลิก
              </button>
              <button 
                type="button" 
                onClick={executeConfirmImport} 
                className="btn btn-primary"
                disabled={isSavingImport || (importValidationReport.valid + (importValidationReport.update || 0)) === 0}
              >
                {isSavingImport ? '⏳ กำลังบันทึก...' : `ยืนยันนำเข้าข้อมูล (${importValidationReport.valid + (importValidationReport.update || 0)} รายการ)`}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* MODAL: Security PIN/Password Verification Modal */}
      {showVerificationModal && (
        <div className="modal-overlay" style={{ zIndex: 200 }}>
          <div className="glassmorphism modal-box" style={{ maxWidth: '400px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--danger)' }}>
              🔒 การรักษาความปลอดภัยแอดมิน
            </h3>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '16px' }}>
              {verificationPrompt || 'กรุณาใส่รหัสผ่านผู้ดูแลระบบเพื่อยืนยันการทำรายการ'}
            </p>
            <form onSubmit={handleVerifyPINSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label className="input-label" htmlFor="verificationPINInput">รหัสผ่านยืนยันตัวตน (Admin Password)</label>
                <input 
                  id="verificationPINInput" 
                  type="password" 
                  className="input-field" 
                  placeholder="ป้อนรหัสผ่าน (รหัสเริ่มต้น: admin1234)" 
                  value={verificationPIN} 
                  onChange={(e) => setVerificationPIN(e.target.value)} 
                  autoFocus
                  required 
                />
              </div>
              
              {verificationError && (
                <div style={{ fontSize: '13px', color: 'var(--danger)', fontWeight: '600' }}>
                  {verificationError}
                </div>
              )}

              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '8px' }}>
                <button type="button" onClick={() => { setShowVerificationModal(false); setVerificationCallback(null); }} className="btn btn-outline" style={{ fontSize: '13px', padding: '6px 16px' }}>ยกเลิก</button>
                <button type="submit" className="btn btn-danger" style={{ fontSize: '13px', padding: '6px 16px' }}>ยืนยันรหัส</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Excel Custom Columns Export Modal */}
      {showExportModal && (
        <div className="modal-overlay" style={{ zIndex: 10000 }}>
          <div className="glassmorphism modal-box" style={{ maxWidth: '540px', display: 'flex', flexDirection: 'column', gap: '20px' }}>

            <div>
              <h2 style={{ fontSize: '20px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                📊 ส่งออกรายงานนักเรียน Excel (กำหนดหัวข้อเอง)
              </h2>
              <p style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
                เลือกหัวข้อและคอลัมน์ประชากรนักเรียนที่คุณต้องการสกัดพิมพ์ออกเป็นไฟล์ Excel
              </p>
            </div>

            {/* Subject Selector for Scores */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)' }}>
                🎯 วิชาเรียนที่ส่งออกคะแนน (เลือกวิชาเพื่อกรอกคะแนน หรือ ปล่อยว่างเพื่อดูเฉลี่ยทุกวิชา)
              </label>
              <select 
                className="input-field" 
                value={exportSelectedSubject} 
                onChange={(e) => setExportSelectedSubject(e.target.value)}
                style={{ fontSize: '13px', padding: '8px 12px', background: 'var(--bg-input)' }}
              >
                <option value="">-- รวมสถิติค่าเฉลี่ยทุกวิชา --</option>
                {subjects.map(s => (
                  <option key={s.id} value={s.id}>[{s.code}] {s.name}</option>
                ))}
              </select>
            </div>

            {/* Checkboxes */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', margin: '8px 0' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.studentCode} onChange={(e) => setSelectedColumns({ ...selectedColumns, studentCode: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                รหัสนักเรียน
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.prefix} onChange={(e) => setSelectedColumns({ ...selectedColumns, prefix: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                คำนำหน้า
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.name} onChange={(e) => setSelectedColumns({ ...selectedColumns, name: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                ชื่อ-นามสกุล
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.grade} onChange={(e) => setSelectedColumns({ ...selectedColumns, grade: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                ระดับชั้น
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.room} onChange={(e) => setSelectedColumns({ ...selectedColumns, room: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                ห้องเรียน
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.no} onChange={(e) => setSelectedColumns({ ...selectedColumns, no: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                เลขที่
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.roomType} onChange={(e) => setSelectedColumns({ ...selectedColumns, roomType: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                ประเภทห้อง
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.status} onChange={(e) => setSelectedColumns({ ...selectedColumns, status: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                สถานะภาพการเรียน
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.scorePre} onChange={(e) => setSelectedColumns({ ...selectedColumns, scorePre: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                คะแนน Pre-Test
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.scorePost} onChange={(e) => setSelectedColumns({ ...selectedColumns, scorePost: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                คะแนน Post-Test
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                <input type="checkbox" checked={selectedColumns.gain} onChange={(e) => setSelectedColumns({ ...selectedColumns, gain: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                พัฒนาการ (Gain)
              </label>
              {exportSelectedSubject !== '' && (
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                  <input type="checkbox" checked={selectedColumns.evaluation} onChange={(e) => setSelectedColumns({ ...selectedColumns, evaluation: e.target.checked })} style={{ width: '15px', height: '15px' }} />
                  ผลการประเมินวิชา
                </label>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '12px' }}>
              <button type="button" onClick={() => setShowExportModal(false)} className="btn btn-outline" style={{ padding: '10px 20px' }}>ยกเลิก</button>
              <button 
                type="button" 
                onClick={handleExportCustomExcel} 
                className="btn btn-primary"
                style={{ padding: '10px 20px', fontWeight: '700' }}
              >
                📥 ดาวน์โหลดไฟล์ Excel (.xlsx)
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  )
}
export default AdminAcademic
